import React, { useState } from "react";
import "../Css/Yearpage.css";
import Nav from "../Utils/Nav";
import Footer from "../Utils/Footer";
import { Link, useParams } from "react-router-dom";



const researchData = {
  2017: {
    conferencedata: [
      {
        title:
          "Naveen James., and Sitharam, T. G. (2017). “Multicriteria Based Landslide Hazard Assessment And Vulnerability Studies For The State Of Sikkim, India.”16th World Conference on Earthquake Engineering Santiago-Chile.",
      },
      {
        title:
          "Sitharam T.G., and Naveen James. (2017). “Liquefaction Susceptibility Analysis for an Offshore Site Based on Index Properties and Geotechnical Field Test Data. 16th World Conference on Earthquake Engineering Santiago-Chile.",
      },
      {
        title:
          "Rajput AS and Sharma UK, 'Toward the Design of Sustainable Reinforced Concrete Columns in Corrosive & Seismically Active Areas', Conference of GFRP Reinforced Concrete Toward Sustainable Concrete, CGSI-2017, Organised By IC-IMPACTS at University of Toronto, Canada.",
      },
      {
        title:
          "Avanoor, G., Rahul,T.M., 2017. Traffic Management on Two – Lane Rural Highways. ASCE India Conference. DOI:https://doi.org/10.1061/9780784482025.080.",
      },
      {
        title:
          "Chavan, S. R., (2017). Study of self-similarity properties of stream networks in catchment of Beas River basin, 22nd International Conference on Hydraulics, Water Resources and Coastal Engineering, L. D. College of Engineering, Ahmedabad, Gujarat, India December 21-23, 2017, ISH - HYDRO 2017 International, (Reference ID: HYD17-313).",
      },
      {
        title:
          "Avanoor, G., Rahul,T.M., 2017. Traffic Management on Two – Lane Rural Highways. ASCE India Conference. DOI:https://doi.org/10.1061/9780784482025.080.",
      },
      {
        title:
          "Mitkari, K. V., Tiwari, R. K. and Arora, M. K., (2017) “Comparative evaluation of filters for smoothing the glacier surface velocity estimates”, In proceedings of 38th Asian Conference on Remote Sensing on Space Applications: Touching Human Lives, October 23- 27, 2017, New Delhi (India). (Full Length Paper)",
      },
      {
        title:
          "Saini, V. and Tiwari, R. K., (2017) “Effect of urbanization on land surface temperature and NDVI: A case study of Dehradun, India”, In proceedings of 38th Asian Conference on Remote Sensing on Space Applications: Touching Human Lives, October 23-27, 2017, New Delhi (India). (Full Length Paper)",
      },
      {
        title:
          "Tiwari, R. K., Malik, K. and Arora, M. K., (2017) “Urban subsidence detection using the Sentinel-1 multi-temporal InSAR data”, In proceedings of 38th Asian Conference on Remote Sensing on Space Applications: Touching Human Lives, October 23-27, 2017, New Delhi (India). (Full Length Paper)",
      },
      {
        title:
          "Ganguly S. Temperature distribution and thermal performance of an aquifer thermal energy storage system. Abstract and poster presentation in European Geosciences Union (EGU) General Assembly 2017 abstracts. Vienna. Apr 2017.",
      },
      {
        title:
          "Ganguly S. Thermal performance of an aquifer while charging-discharging thermal energy. Abstract in 9th International Conference on Porous Media & Annual Meeting, InterPore (International Society for Porous Media). Rotterdam, The Netherlands, May 2017.",
      },
      {
        title:
          "Ganguly S, Schotting Ruud J., Raoof A. High-resolution visualization of free surface flow- porous media flow interaction using micromodel. Abstract and poster presentation at 2nd SRP-NUPUS Meeting, Mühlhausen im Täle, Germany, Oct 2017.",
      },
      {
        title:
          "Ratan Sarmah and Gautam Barua (2017). Analysis of Three-Dimensional Transient Seepage into Ditch Drains from a Ponded Field. Sadhana 42(5), 769-793.",
      },
    ],

    bookdata: [
      {
        title:
          "Sahoo, J. P., and R. Ganesh. 2017. Active earth pressure on retaining walls with unsatu- rated soil backfill. Publisher: Ground Improvement and Earth Structures. Sustainable Civil Infrastructures. Springer, Cham. ISBN 978-3-319-63889-8. https://doi.org/10.1007/978-3-319-63889-8_1",
      },
    ],

    journaldata: [
      {
        title:
          "Suluguru, A. K., Jayatheja, M., Kar, A., GuhaRay, A., Surana, S.R., & Naveen James. (2017). Experimental studies on the microstructural, physical and chemical characteristics of building derived materials to assess their suitability in ground improvement. Construction and Building Materials, 156, 921-932. [DOI Link](https://doi.org/10.1016/j.conbuildmat.2017.09.058)",
      },
      {
        title:
          "Chavan, S. R., and Srinivas, V. V. (2017). Regionalization based envelope curves for PMP estimation by Hershfield method. International Journal of Climatology, Wiley & Royal Meteorological Society, [DOI Link](https://doi.org/10.1002/joc.4951) (Impact factor: 4.069 and Q1 journal).",
      },
      {
        title:
          "Awasthi S, Rajput AS and Sharma UK, 'FRP as a Confinement Reinforcement in RCC Columns 39;', Ambuja Technical Journal. 7 (2018) 34–39.",
      },
      {
        title:
          "Rajput AS and Sharma UK, ‘Seismic Behavior of Under Confined Square Reinforced Concrete Columns’, Structures (Elsevier), 13 (2017), 26–35, [DOI Link](https://doi.org/10.1016/j.istruc.2017.10.005), IF – 1.4.",
      },
      {
        title:
          "Rahul, T.M., Verma, A., 2017. The influence of stratification by motor-vehicle ownership on the impact of built environment factors in Indian cities. Journal of Transport Geography (58), 40-51 (Elsevier).",
      },
      {
        title:
          "Mayur Pisode, Mitesh Surana, Putul Haldar and Yogendra Singh (2017) “Comparative Assessment of Seismic Fragility of RC Frame Buildings Designed for Older and Revised Indian Standards” ISET Journal of Earthquake Engineering, Paper No. 534, Vol. 54, No. 1, March 2017, pp. 17-29.",
      },
      {
        title:
          "Mitkari, K., Arora, M. K. and Tiwari, R. K., (2017) Extraction of Glacial Lakes in Gangotri Glacier Using Object-Based Image Analysis,” IEEE Journal of Selected Topics in Applied Earth Observations and Remote Sensing, Volume 10 (12), pp 5275-5283. (Q1)",
      },
      {
        title:
          "Goet, G., Sonkar, I., Kumar, S., Hari Prasad, K. S., & Ojha, C. S. P. (2024). Effect of Salinity on Crop Growth and Soil Moisture Dynamics: A Study with Root Water Uptake Model. Journal of Hazardous, Toxic, and Radioactive Waste, 28(3). [DOI Link](https://doi.org/10.1061/JHTRBP.HZENG-1299)",
      },
      {
        title:
          "Kumar, A., Sonkar, I., & Sarmah, R. (2024). Modeling root zone water and salt transport using matric flux potential based root water uptake distribution. Journal of Hydrology, 630, 130712. [DOI Link](https://doi.org/10.1016/j.jhydrol.2024.130712)",
      },
      {
        title:
          "Ganesh, R., and J. P. Sahoo. 2017. Seismic passive resistance of cohesive-frictional soil medium: a kinematic limit analysis. International Journal of Geomechanics, ASCE. 17(8), 04017029. Impact Factor: 3.918/2021. [DOI Link](https://doi.org/10.1061/(ASCE)GM.1943-5622.0000896)",
      },
      {
        title:
          "Ganesh, R., S. Khuntia, and J. P. Sahoo. 2017. Bearing capacity of shallow strip foundations in sand under eccentric and/or oblique loads. International Journal of Geomechanics, ASCE. 17(4), 06016028. Impact Factor: 3.918/2021. [DOI Link](https://doi.org/10.1061/(ASCE)GM.1943-5622.0000799)",
      },
      {
        title:
          "Ganesh, R., and J. P. Sahoo. 2017. Vertical uplift resistance of plate anchors with the fluctuations of ground water table. International Journal of Geosynthetics and Ground Engineering, Springer. 3(8), 1–8. [DOI Link](https://doi.org/10.1007/s40891-017-0084-8)",
      },
      {
        title:
          "Ratan Sarmah and Gautam Barua (2017). Analysis of Three-Dimensional Transient Seepage into Ditch Drains from a Ponded Field. Sadhana 42(5), 769-793.",
      },
    ],
  },

  2018: {
    conferencedata: [
      {
        title:
          "Gupta, N. and Chavan, S. R., (2018). Behaviour of extreme rainfall over India, 1st International Conference on Sustainable Water Management, 10-11 December 2018, Chandigarh, India.",
      },
      {
        title:
          "Maheshwari, S. and Chavan, S. R., (2018). Magnitude frequency analysis to assess effective discharge for sediment transport in Godavari River basin, 1st International Conference on Sustainable Water Management, 10-11 December 2018, Chandigarh, India.",
      },
      {
        title:
          "Maheshwari, S. and Chavan, S. R., (2018). Determination of Effective Discharge responsible for sediment transport in Cauvery River basin, 23rd International Conference on Hydraulics, Water Resources and Coastal Engineering, National Institute of Technology Patna, India December 19-21, 2018, ISH - HYDRO 2018 International, (Reference Number :118).",
      },
      {
        title:
          "Gupta, N. and Chavan, S. R.,(2018). Assessment of tail behavior of probability distributions of daily precipitation data over India, 23rd International Conference on Hydraulics, Water Resources and Coastal Engineering, National Institute of Technology Patna, India December 19-21, 2018, ISH - HYDRO 2018 International, (Reference Number :118).",
      },
      {
        title:
          "Shobhit Maheshwari, and Chavan, S. R.,(2018). Assessment of impact of change in DEM resolution on sediment yield in Beas River basin, India, European Geosciences Union General Assembly 2018, Vienna, Austria, Vol. 20, EGU2018-14795, 2018.",
      },
      {
        title:
          "Sonali Pattnaik, and Chavan, S. R.,(2018). Hydro-climatological Change Detection in Cauvery River Basin of India, European Geosciences Union General Assembly 2018, Vienna, Austria, Vol. 20, EGU2018-15549, 2018.",
      },
      {
        title:
          "Rajput AS and Sharma UK; Calibration of Faraday’s Law in Simulating Accelerated Corrosion for RC Structures & the RILEM week 2018 & The 4th International Conference of Service Life design for Infrastructures (SLD-4), TU Delft, The Netherlands.",
      },
      {
        title:
          "Rajput AS and Sharma UK, Effects of Corrosion on Seismic Behaviour of RC Columns, 5th International Corrosion Prevention Symposium for Research Scholars, CORSYM-2018, Organized by NACE International, 2018 at IIT Chennai, India.",
      },
      {
        title:
          "Awasthi S, Rajput AS, and Sharma UK, FRP as a Confinement Reinforcement In RCC39; International Conference on Advances in Construction Materials and Structures-2018, Organized by ACMS at IIT Roorkee, India.",
      },
      {
        title:
          "Sharma M, Surana M, Singh Y and Burton H (2018). Seismic Vulnerability of RC Moment Frame Buildings Designed as per Latest IS Codes, 16th Symposium on Earthquake Engineering, Indian Institute of Technology Roorkee, Roorkee, India.",
      },
      {
        title:
          "Lang DH, Singh Y, Surana M, Meslem A and Molina S (2018). Earthquake Loss Estimation – Potential Applications in Indian Subcontinent, 16th Symposium on Earthquake Engineering, Indian Institute of Technology Roorkee, Roorkee, India.",
      },
      {
        title:
          "Mitkari, K. V., Tiwari, R. K., Arora, M. K. and Sofat, S. (2018). Geometric Accuracy Assessment of Large Scale Glacier Cover Map Derived using Object Based Image Analysis. AGU Fall Meeting Abstracts, #H31H-2002, Washington, D.C., 10-14 December 2018.",
      },
      {
        title:
          "Saini, V., Tiwari, R.K. (2018). Remote sensing based time-series analysis for monitoring urban sprawl: A case study of Chandigarh capital region. In: Proceedings of National Symposium on Advancements in Geospatial Technology for Societal Benefits, Space Applications Center (ISRO), 5-7 December 2018, Ahmedabad, India.",
      },
      {
        title:
          "Saini, V., Tiwari, R.K. (2018). An object-based image analysis approach for determining the pattern of urban growth in the first planned city of India. In: Proceedings of Remote Sensing Technologies and Applications in Urban Environments III, (9 October 2018); SPIE Remote Sensing, 10-13 Sept. 2018, Berlin, Germany, vol. 10793, pp. 107930T-1 – 107930T-8. doi: 10.1117/12.2502077.",
      },
      {
        title:
          "Mitkari, K. V., Arora, M. K. and Tiwari, R. K., (2018) “Detecting glacier surface changes using object-based change detection’ In: Proceedings of IEEE International Geosciences and Remote Sensing Symposium 2018, 23rd-27th July, Valencia, Spain (Full Length Paper).",
      },
      {
        title:
          "Sebastian, R & Sitharam, T. G. (2018) “Numerical simulation of wave propagation across multiple parallel rock joints using DEM”. Indian Geotechnical Conference, December 13-15, Bangalore, India, Proceedings, Paper ID Th10_008.",
      },
      {
        title:
          "Ganguly S, J. H. van Lopik., R J Schotting, G Yuce. Mathematical model of fast high-volume infiltration into subsurface. Computational Methods in Water Resources (CMWR)-XXII. Saint-Malo, France, June 2018.",
      },
      {
        title:
          "Ratan Sarmah and Shubham Tiwari (2018). A Two-Dimensional Transient Analytical Solution for a Ponded Ditch Drainage System under the Influence of Source/Sink. Journal of Hydrology 558, 196-204.",
      },
    ],

    bookdata: [
      {
        title: "No Data.",
      },
    ],

    journaldata: [
      {
        title:
          "Rajput AS and Sharma UK, ‘Corroded reinforced concrete columns under simulated seismic loading,’ Engineering Structures (Elsevier). 171 (2018), 453-463, DOI: https://doi.org/10.1016/j.engstruct.2018.05.097, IF - 3.4.",
      },
      {
        title:
          "Verma, M., Rahul, T.M., Vinayak, P., Verma, A., 2018. Influence of childhood and adulthood attitudinal perceptions on bicycle usage in the Bangalore city. Journal of Transport Geography(72), 94-105 (Elsevier).",
      },
      {
        title:
          "Rahul, T.M., Verma, A., 2018. Sustainability analysis of pedestrian and cycling infrastructure A case study for Bangalore. Case studies on Transport Policy 6(4), 483 - 493 (Elsevier).",
      },
      {
        title:
          "Verma, A., Verma, M., Rahul, T.M., Khurana, S., Rai, A., 2018. Acceptable trip distance for walking in mass religious gatherings—A case study of world’s largest human gathering Kumbh Mela in Ujjain, India. Sustainable Cities and Society (41), 505-512 (Elsevier).",
      },
      {
        title:
          "Raheena, M. and Robinson, R. G. (2018) Determination of Coefficient of Secondary Compression in Accelerated Incremental Loading Consolidation Test. Lecture notes in Civil Engineering: Geotechnical Characterization and Modelling, Proceedings of IGC 2018, Vol 85: 1113-1125.",
      },
      {
        title:
          "Raheena, M. and Robinson, R. G. (2017) Accelerated consolidation test using method. Indian Geotechnical Journal, Vol. 48, No. 1, pp. 84-91. (Impact factor 1.6).",
      },
      {
        title:
          "Raheena, M., Sridhar, G and Robinson, R. G. (2018) Constant Rate of Strain Consolidation Testing using Conventional Fixed Ring Consolidation Cell. Indian Geotechnical Journal, Vol. 49, No. 2, pp. 141-150. (Impact factor 1.6).",
      },
      {
        title:
          "Surana M, Singh Y and Lang DH (2018). Effect of URM Infills on Inelastic Floor Response of RC Frame Buildings, Engineering Structures, 175, 861-878, DOI: https://doi.org/10.1016/j.engstruct.2018.08.078.",
      },
      {
        title:
          "Surana M, Singh Y and Lang DH (2018). Effect of Irregular Structural Configuration on Floor Acceleration Demand in Hill-side Buildings, Earthquake Engineering and Structural Dynamics, 47(10), 2032-2054, DOI: https://doi.org/10.1002/eqe.3054.",
      },
      {
        title:
          "Surana M, Singh Y and Lang DH (2018). Fragility Analysis of Hill-side Buildings Designed for Modern Seismic Design Codes, The Structural Design of Tall and Special Buildings, 27(14), 1-13, DOI: https://doi.org/10.1002/tal.1500.",
      },
      {
        title:
          "Sharma M, Surana M, Singh Y and Burton H (2018). Seismic Vulnerability of RC Moment Frame Buildings Designed as per Latest IS Codes, 16th Symposium on Earthquake Engineering, Indian Institute of Technology Roorkee, Roorkee, India.",
      },
      {
        title:
          "Lang DH, Singh Y, Surana M, Meslem A and Molina S (2018). Earthquake Loss Estimation – Potential Applications in Indian Subcontinent, 16th Symposium on Earthquake Engineering, Indian Institute of Technology Roorkee, Roorkee, India.",
      },
      {
        title:
          "Surana M, Singh Y and Lang DH (2018). Effect of Strong-column Weak-beam Design on Seismic Fragility of RC Frame Buildings, International Journal of Advanced Structural Engineering, 10(2), 131-141, DOI: https://doi.org/10.1007/s40091-018-0187-z.",
      },
      {
        title:
          "Surana M, Singh Y and Lang DH (2018). Floor Spectra of Inelastic RC Buildings Considering Ground-motion Characteristics, Journal of Earthquake Engineering, 22(3), 488-519, DOI: https://doi.org/10.1080/13632469.2016.1244134.",
      },
      {
        title:
          "Sonkar, I., Hari Prasad, K. S., & Ojha, C. S. P. (2018). Estimation of non-linear root water uptake parameter using genetic algorithms. ISH Journal of Hydraulic Engineering, 24(2), 165–171. https://doi.org/10.1080/09715010.2017.1400411.",
      },
      {
        title:
          "Sonkar, I., Kaushika, G S, & Prasad, K. S. H. (2018). Modeling Moisture Flow in Root Zone: Identification of Soil Hydraulic and Root Water Uptake Parameters. Journal of Irrigation and Drainage Engineering, 144(10), 1–11. https://doi.org/10.1061/(ASCE)IR.1943.",
      },
      {
        title:
          "Ganguly S, Exact solution of heat transport equation for a heterogeneous geothermal reservoir. Energies (MDPI) (SCI). Vol. 11 (11), Nov 2018. pp. 2935.",
      },
      {
        title:
          "Ganguly S, Date A, and Akbarzadeh A. Effectiveness of bottom insulation of a salinity gradient solar pond. Journal of Solar Energy Engineering (ASME) (SCI). Vol. 140 (4). Mar 2018. pp. 1-5. (In the list of ‘popular contents’ of the journal Mar-Apr 2018).",
      },
      {
        title:
          "Ganguly S, Date A, and Akbarzadeh A. Investigation of thermal performance of a solar pond with external heat addition. Journal of Solar Energy Engineering (ASME) (SCI). Vol. 140 (2). Jan 2018. pp. 1-6. (In the list of popular contents of the journal in Feb-Mar 2018).",
      },
      {
        title:
          "Danie, R., R. Ganesh., A. W. Shakeel., C. Shermi., and J. Venkatesan. 2018. Temperature dependent bond strength model for GFRP laminate externally bonded to heat-damaged concrete. Construction and Building Materials, Elsevier Sci Ltd, England. 190, 526-532. Impact Factor: 7.693/2021. https://doi.org/10.1016/j.conbuildmat.2018.09.133.",
      },
      {
        title:
          "Ganesh, R., and K. C. Vinay. 2018. Determination of required reinforcement force in geosynthetic reinforced soil walls under seismic loadings. International Journal of Geosynthetics and Ground Engineering, Springer. 4(3), 24. https://doi.org/10.1007/s40891-018-0141-y.",
      },
      {
        title:
          "Ganesh, R., S. Khuntia, and J. P. Sahoo. 2018. Seismic uplift capacity of shallow strip anchors: A new pseudo-dynamic upper bound limit analysis. Soil Dynamics and Earthquake Engineering, Elsevier Sci Ltd, England. 109, 69–75. Impact Factor: 4.250/2021. https://doi.org/10.1016/j.soildyn.2018.03.004.",
      },
      {
        title:
          "Sahoo, J. P., and R. Ganesh. 2018. Vertical uplift resistance of rectangular plate anchors in two layered sand. Ocean Engineering, Pergamon-Elsevier Science Ltd, England. 150, 167–175. Impact Factor: 4.372/2021. https://doi.org/10.1016/j.oceaneng.2017.12.056.",
      },
      {
        title:
          "Ganesh, R., and S. Khuntia. 2018. Estimation of pullout capacity of vertical plate anchors in cohesionless soil using MARS. Geotechnical and Geological Engineering, Springer, Netherlands. 36(1), 223–233. https://doi.org/10.1007/s10706-017-0319-4.",
      },
      {
        title:
          "Sahoo, J. P., and R. Ganesh. 2018. Kinematic limit analysis solutions of seismic active earth pressure coefficients. International Journal of Geomechanics, ASCE. 18(1), 04017123. Impact Factor: 3.918/2021. https://doi.org/10.1061/(ASCE)GM.1943-5622.0001030.",
      },
      {
        title:
          "Sitharam, T. G., Sebastian, R & Fazil, F (2018) “Vibration isolation of buildings housed with sensitive equipment using open trenches- Case study and numerical simulations, Soil Dynamics and Earthquake Engineering, Elsevier, 115, 344-351. (Impact Factor: 4.0)",
      },
      {
        title:
          "Sebastian, R & Sitharam, T. G. (2018) “Resonant column tests and non linear elasticity in simulated rocks”, Rock Mechanics Rock Engineering, Springer, 51, 155-172. (Impact Factor:6.2)",
      },
      {
        title:
          "Ratan Sarmah and Shubham Tiwari (2018). A Two-Dimensional Transient Analytical Solution for a Ponded Ditch Drainage System under the Influence of Source/Sink. Journal of Hydrology 558, 196-204.",
      },
    ],
  },

  2019: {
    conferencedata: [
      {
        title:
          "Rajput AS and Sharma UK; Condition Assessment and Seismic Rehabilitation of a Heritage Structure; The 3rd Symposium on Assessment and Intervention of Existing Structures, ACF-2019, Being organized By Asian Concrete Federation (ACF) at Sapporo, Japan.",
      },
      {
        title:
          'Tyagi, A., Tiwari, R.K., James, N. (2019). Landslide Hazard Zonation Using Satellite remote sensing and GIS Technology" National Conference Big Geospatial Data: Analytics, Modelling and Application, Ludhiana, India, Sep 25-26, 2019.',
      },
      {
        title:
          'Guha, S., and Tiwari, R. K. (2019); Trends in Surface Ice Velocity of Zemu Glacier- Annual and Decadal Perspective. " National Conference Big Geospatial Data: Analytics, Modelling and Applications, Ludhiana, India, Sep 25-26, 2019.',
      },
      {
        title:
          "Tripathi, A. and Tiwari R.K. (2019) ‘Spaceborne C-Band DInSAR based Urban Subsidence Mapping of Chandigarh area’, under publication with Bangladesh Institute of Planners. Presented at 1st International Conference on Urban and Regional Planning (ICURP- 2019) at Dhaka Bangladesh on 5TH October 2019, organised by Bangladesh Institute of Planners (BIP) and Ministry of Earth Sciences, People’s Republic of Bangladesh. (Most Memorable Paper Presentation Award).",
      },
      {
        title:
          "Tripathi, A. and Tiwari, R.K. (2019) ‘Mapping of deflection caused due to hydrostatic pressure using DinSAR on Bhakhra dam’, submitted to 6th IEEE UPCON to be held in December 2019 at Aligarh Muslim University.",
      },
      {
        title:
          "Tiwari, R.K. (2019), “Glacial Retreat: Climate Change is Responsible - Geomorphology Hastens the Process.” Presented in International Workshop on Climate Change and Extreme Events in the Himalayan Region, IIT Mandi, 18-20 April, 2019, Mandi, India.",
      },
      {
        title:
          "Tripathi, A. and Tiwari R.K. (2019), ‘Utilisation of Spaceborne C- Band SAR data for Analysis of Flood impact on Agriculture and its Management’, In The International Archives of the Photogrammetry, Remote Sensing and Spatial Information Sciences Volume XLII-3/W6, 2019 (August), p.p. 2-6. doi: 10.5194/isprs-archives-XLII-3-W6-521-2019.",
      },
      {
        title:
          "Tripathi, A. and Tiwari, R. K. (2019), “C-band SAR Interferometry based flood inundation mapping for Gorakhpur and adjoining areas”. In ICCECE 2019, Kolkata, Publication awaited. (Best Paper Award)",
      },
      {
        title:
          "Saini, V., Tiwari, R.K. (2019). Monitoring urban sprawl using object-based image analysis of multi-temporal remote sensing data. In: Proceedings of Women Science Congress, 106th Indian Science Congress, 5-6 January 2019, LPU, Punjab, India.",
      },
      {
        title:
          "Estimation of Soil Water Retention Characteristics of a Novel Artificial Recharge System located in Laporiya, Rajasthan. Jaswant Singh, Vijay A Loganathan, Deepak Kashyap, Anupama Sharma,Rakesh Sharma, Alison Parker, Pablo Compo Moreno, Kristell Le Corre Pidou, Basant Y.2019/11.International Groundwater Conference 2019, Roorkee, India.",
      },
      {
        title:
          "Sebastian, R & Mishra, B. (2019) “Numerical investigation of massive roof failure in an underground coal mine in Pittsburgh seam”, Rock mechanics for natural resources and infrastructure development,14th International ISRM Congress, 13-18 September, Foz do Iguassu, Brazil, 2895-2901.",
      },
    ],

    bookdata: [
      {
        title: "No Date.",
      },
    ],

    journaldata: [
      {
        title:
          "Maheshwari, S and Chavan, S R. (2019). Magnitude-Frequency-Analysis to assess effective discharge at daily and monthly time scales in South Indian River Basins. ISH Journal of Hydraulic Engineering, doi: 10.1080/09715010.2019.1603088 (CiteScore (Scopus): 4.5 and Q2 journal).",
      },
      {
        title:
          "Rajput AS, Sharma UK and Engineer K, ‘Seismic retrofitting of corroded RC columns using advanced composite materials’, Engineering Structures (Elsevier), 181 (2019), 35-46, DOI: https://doi.org/10.1016/j.engstruct.2018.12.009, IF – 3.4.",
      },
      {
        title:
          "Rajput AS and Sharma UK, ‘Performance of aged reinforced concrete columns under simulated seismic loading’, Structural Concrete (Wiley), 20 (2019), 1123-1136, DOI:https://doi.org/10.1002/suco.201800235, IF – 1.9.",
      },
      {
        title:
          "Rajput AS and Sharma UK, ‘Seismic upgrade of corroded confined reinforced concrete columns using composite materials’, ACI Materials, 116 (2019), pp 1-12, DOI: https://doi.org/10.14359/51716825, IF -1.3.",
      },
      {
        title:
          "Verma, A., Verma, M., Rahul, T.M., Khurana, S., Rai, A., 2019. Measuring accessibility of various facilities by walking in world’s largest mass religious gathering – Kumbh Mela. Sustainable Cities and Society (45), 79-86 (Elsevier).",
      },
      {
        title:
          "Raheena, M., Sridhar, G. and Robinson, R. G. (2019) Simplified Apparatus for CRS Consolidation Testing of Soils. Geotechnical Testing Journal, 42(3): 817-828, ASTM International (Impact factor 1.5).",
      },
      {
        title:
          "Surana M (2019). Evaluation of Seismic Design Provisions for Acceleration-sensitive Non-structural Components, Earthquakes and Structures – An International Journal, 16(5), 611-623, DOI: http://dx.doi.org/10.12989/eas.2019.16.5.611.",
      },
      {
        title:
          "Saini, V., and Tiwari, R.K. (2019). Remote sensing-based time-series analysis for monitoring urban sprawl: A case study of Chandigarh capital region. Journal of Geomatics, 13(1): 94-97.",
      },
      {
        title:
          "Sonkar, I., Kotnoor, H. P., & Sen, S. (2019). Estimation of root water uptake and soil hydraulic parameters from root zone soil moisture and deep percolation. Agricultural Water Management, 222. https://doi.org/10.1016/j.agwat.2019.05.037",
      },
      {
        title:
          "Ganguly S, Date A, and Akbarzadeh A. On increasing the thermal mass of a salinity gradient solar pond with external heat addition: a transient study. Energy (Elsevier) (SCI). Vol. 168, Feb 2019. pp. 43-56.",
      },
      {
        title:
          "Ganesh, R., and S. Rajesh. 2019. Analytical solution to estimate the point of application of resultant passive earth thrust against unsaturated retaining structures. Geomechanics and Geoengineering, Taylor Francis Ltd, United Kingdom. 16(6), 509—516. https://doi.org/10.1080/17486025.2019.1680880",
      },
      {
        title:
          "Sahoo, J. P., and R. Ganesh. 2019. Seismic uplift resistance of circular plate anchors in sand. Proceedings of the Institution of Civil Engineers-Geotechnical Engineering, ICE Publishing, England. 172(1), 55–66. Impact Factor: 1.953/2021. https://doi.org/10.1680/jgeen.17.00124",
      },
      {
        title:
          "Ganesh, R., and J. P. Sahoo. 2019. Vertical uplift capacity of a group of shallow circular plate anchors in sand. Marine Georesources and Geotechnology, Taylor & Francis Inc, United States. 37(3), 282–290. Impact Factor: 2.605/2021. https://doi.org/10.1080/1064119X.2017.1410868.",
      },
    ],
  },

  2020: {
    conferencedata: [
      {
        title:
          "R.M Kannan, P. Haldar, and Naveen James. (2020), “Behaviour of Mid-Rise Buildings with Shear Wall Rocking Foundation System on Medium Dense Site”, Proceedings of the Second ASCE India Conference on “Challenges of Resilient and Sustainable Infrastructure Development in Emerging Economies (CRSIDE2020)” 2-4 March 2020, Kolkata.",
      },
      {
        title:
          "R.M Kannan, Naveen James, and P. Haldar (Accepted), “Influence of Soil Types on Seismic Behaviour of RC Framed Building with Shear Wall on Rocking Foundation”, 17thWorld Conference on Earthquake Engineering, September 13-18, 2020, Sendai, Japan. Paper No. C000996.",
      },
      {
        title:
          "Tyagi, A, Tiwari, R.K and Naveen James. (2020)- GIS-Based Landslide Hazard Zonation and Risk Studies Using MCDM, Springer.",
      },
      {
        title:
          "Chavan, S. R. and Shobhit Maheshwari, (2020). Assessment of sediment transfer based on discharge indices for Cauvery River basin, India, European Geosciences Union General Assembly 2020, Vienna, Austria, EGU2020-8108.",
      },
      {
        title:
          "Maheshwari, S. and Chavan, S. R., (2020). Assessment of impact of hysteresis phenomenon on Magnitude-Frequency Analysis for Godavari River basin, India, American Geophysical Union 2020 Fall Meeting, AGU2020-691944.",
      },
      {
        title:
          "Gupta, N., and Chavan, S. R., (2020). Characterization of Extreme precipitation over India, European Geosciences Union General Assembly 2020, Vienna, Austria, EGU2020-12883.",
      },
      {
        title:
          "Rahul, T. M., Megha, M., Meenakshi, S., Madhavendra, K., Verma, A., 2020. Gender Differences in Work Trip Generation: Evidences from Bangalore. Transportation Research Procedia, Volume 48, 2800-2810.",
      },
      {
        title:
          "P. L. Kurmi, and P. Haldar, (2020), “Comparative Study of Seismic Fragility of Indian RC Buildings Designed with Old and Revised Seismic Code”, 17th World Conference on Earthquake Engineering, September 13-18, Sendai, Japan. Paper No. C002041.",
      },
      {
        title:
          "K. K. K. Reddy, and P. Haldar (2020), “Comparative Study of Seismic Design Guidelines of Major National Building Codes for RC Shear Walls”, 17th World Conference on Earthquake Engineering, September 13-18, Sendai, Japan. Paper No. C001834.",
      },
      {
        title:
          "R.M Kannan, N. James, and P. Haldar (2020), “Influence of Soil Types on Seismic Behaviour of RC Framed Building with Shear Wall on Rocking Foundation”, 17th World Conference on Earthquake Engineering, September 13-18, Sendai, Japan. Paper No. C000996.",
      },
      {
        title:
          "R.M Kannan, P. Haldar, and N. James (2020), “Behaviour of Mid Rise Buildings with Shear Wall Rocking Foundation System on Medium Dense Site”, Proceedings of the Second ASCE India Conference on “Challenges of Resilient and Sustainable Infrastructure Development in Emerging Economies (CRSIDE2020)” 2-4 March 2020, Kolkata, pp:1366-1371.",
      },
      {
        title:
          "S. Singh, Tiwari, R.K, V. Sood, (2020) “Cloud removal for satellite image using fusion of SCATSAT-1and MODIS data”, 3rd Conference of the Arabian Journal of Geosciences, Springer Nature, Tunisia on 2-4 November, 2020 (In-press)",
      },
      {
        title:
          "S. Singh, Tiwari, R.K., V. Sood (2020) “Estimation and Validation of Enhanced Resolution Brightness Temperature Products of SCATSAT- 1”, in IEEE 5th International Conference on Computing Communication and Automation (ICCCA), Galgotias University, Greater Noida, UP, India. Oct 30-31, 2020, DOI: 10.1109/ICCCA49541.2020.9250718.",
      },
      {
        title:
          "S. Singh, Tiwari, R.K., V. Sood (2020) “Unsupervised snow cover classification using dual-polarized SCATSAT-1 satellite data”, International Conference on Soft Computing and Signal Processing (ICSCSP-2020), 21-22 August, Malla Reddy College of Engineering & Technology, Hyderabad, Telangana, India. (In-press)",
      },
      {
        title:
          'Tyagi, A., Tiwari, R.K., James, N. (2020). " GIS-Based Landslide Hazard Zonation and Risk Studies Using MCDM." The 7th International Conference on Recent Advances in Geotechnical Earthquake Engineering and Soil Dynamics (ICRAGEE) Indian Institute of Science, Bangalore during July 13-16, 2020.',
      },
      {
        title:
          "Report on Pollution Mapping of River Ganga, India. V Bhatt, M Verma, VA Loganathan. Second United Nations World Geospatial Information Congress. Hyderabad, India.",
      },
      {
        title:
          "Interaction of Uranium Contaminated Groundwater with Alluvial Soils of Punjab. V Goriya, VA Loganathan Roorkee Water Conclave 2020.",
      },
      {
        title:
          "Ratan Sarmah and Ainal Hoque Gazi (2020). Analytical Steady-State Solution for a Three-Dimensional Partially Penetrating Ditch Drainage System Receiving Water from an Uneven Ponding Field. Journal of Irrigation and Drainage Engineering (ASCE) 146(12), 06020011.",
      },
      {
        title:
          "Ratan Sarmah, Gautam Barua and Suresh A. Kartha (2020). Experimental and Analytical Investigation of Ponded Ditch Drainage System with Temporal Boundaries. Journal of Hydrologic Engineering (ASCE) 25(12), 04020052.",
      },
    ],

    bookdata: [
      {
        title:
          "Maheshwari, S. and Chavan, S. R., (2020). Determination of Effective Discharge responsible for Sediment Transport in Cauvery River basin. Water Sci., Technol. Library, Vol. 98, Ramakar Jha et al. (Eds): Climate Change Impacts on Water Resources, 978-3-030-64201-3, 492330_1_En, Chapter 12.",
      },
      {
        title:
          "Gupta, N. and Chavan, S. R., (2020). Assessment of tail behavior of probability distributions of daily precipitation data over India. Water Sci., Technol. Library, Vol. 98, Ramakar Jha et al. (Eds): Climate Change Impacts on Water Resources, 978-3-03064201-3, 492330_1_En, Chapter 1.",
      },
    ],

    journaldata: [
      {
        title:
          "Rajput AS and Sharma UK, ‘Calibration of accelerated corrosion protocol for reinforced concrete columns’, Journal of Current Science, Vol. 118, January 2020, IF – 1.102 (Q2), Scopus.",
      },
      {
        title:
          "Rahul, T.M, Manoj., M.,2020. Categorization of pedestrian level of service perceptions and accounting its response heterogeneity and latent correlation on travel decisions. Transportation Research Part A 142, 40–55 (Elsevier).",
      },
      {
        title:
          "Ashok Kumar, T., Raheena, M., Robinson, R. G. and Thyagaraj, T. (2020) A Rapid Method of Determination of Swell Potential and Swell Pressure of Expansive Soils Using Constant Rate of Strain Apparatus. Geotechnical Testing Journal, 43 (6): 1368-1378, ASTM International (Impact factor 1.5).",
      },
      {
        title:
          "Surana M (2020). Seismic Fragility Curves using Pulse-like and Spectrally Equivalent Ground-motion Records, Earthquakes and Structures – An International Journal, 19(2), 79-90, DOI: https://doi.org/10.12989/eas.2020.19.2.079.",
      },
      {
        title:
          "Surana M, Meslem A, Singh Y and Lang DH (2020). Analytical Evaluation of Damage Probability Matrices for Hill-side RC Buildings using Different Seismic Intensity Measures, Engineering Structures, 207, DOI: https://doi.org/10.1016/j.engstruct.2020.110254.",
      },
      {
        title:
          "Singh, S., Tiwari, R. K., Gusain, H. S., & Sood, V. (2020). Potential applications of SCATSAT-1 satellite sensor: a systematic review. IEEE Sensors Journal, 20(21), 12459-12471. (Q1).",
      },
      {
        title:
          "Saini, V., and Tiwari, R.K. (2020) “A systematic review of urban sprawl studies in India: A geospatial data perspective”, Arabian Journal of Geosciences, 13(17), pp.1-21. (Q2)",
      },
      {
        title:
          "Ganesh, R., and J. P. Sahoo. 2020. Seismic stability of obliquely loaded circular plate anchors. Ocean Engineering, Pergamon-Elsevier Science Ltd, England. 217, 107856. Impact Factor: 4.372/2021. https://doi.org/10.1016/j.oceaneng.2020.107856.",
      },
      {
        title:
          "Ganesh, R., and J. P. Sahoo. 2020. Coupled bearing capacity factor for strip foundations on cohesive-frictional soil slopes under static and seismic conditions. International Journal of Geomechanics, ASCE. 20(11), 04020202. Impact Factor: 3.918/2021. https://doi.org/10.1061/(ASCE)GM.1943-5622.0001851.",
      },
      {
        title:
          "Ganesh, R. 2020. Vertical uplift resistance of close-spaced shallow rectangular group anchor plates embedded in sand. Marine Georesources and Geotechnology, Taylor & Francis Inc, United States. 38(9), 1070–1081. Impact Factor: 2.605/2021. https://doi.org/10.1080/1064119X.2019.1650403.",
      },
      {
        title:
          "Ratan Sarmah and Ainal Hoque Gazi (2020). Analytical Steady-State Solution for a Three-Dimensional Partially Penetrating Ditch Drainage System Receiving Water from an Uneven Ponding Field. Journal of Irrigation and Drainage Engineering (ASCE) 146(12), 06020011.",
      },
      {
        title:
          "Ratan Sarmah, Gautam Barua and Suresh A. Kartha (2020). Experimental and Analytical Investigation of Ponded Ditch Drainage System with Temporal Boundaries. Journal of Hydrologic Engineering (ASCE) 25(12), 04020052.",
      },
    ],
  },

  2021: {
    conferencedata: [
      {
        title:
          "Gupta, N., and Chavan, S. R., (2021). Frequency analysis incorporating decision support system over Mahanadi catchment in India, HYDRO 2021 INTERNATIONAL.",
      },
      {
        title:
          "Souparna Chakraborty, Nilanjan Mondal, Putul Haldar, Prabir Sarkar and Chirodeep Bakli, “Passive Building Cooling Using Tree-Shaped Converging Microchannel Nets” 2nd International Conference on Recent Advances in Fluid and Thermal Sciences (ICRAFT 2020), organized by BITS Pilani, Dubai Campus, 19 March 2021 - 21 March 2021. (Won best paper award).",
      },
      {
        title:
          "Manoj Kannan, Rajamanickam, Naveen James, Putul Haldar “Effect of Soil Structure on RC Buildings with Varying Shear Wall Placement” 6th International Conference on Earthquake Engineering and Seismology (6ICEES 2021), hosted by Gebze Technical University (GTU) Civil Engineering Department. The conference will take place at GTU Congress and Cultural Center (GTU-CCC), Gebze, Turkey between October 13th -15th 2021.",
      },
      {
        title:
          "Singh, S., Tiwari, R.K., Sood, V. and Prashar, S., (2021) Unsupervised snow cover classification using dual-polarized SCATSAT-1 satellite data. In Soft Computing and Signal Processing: Proceedings of 3rd ICSCSP 2020, Volume 1 (pp. 627-635). Springer Singapore.",
      },
      {
        title:
          "Singh, S. and Tiwari, R.K., (2021, July) Detection of cryospheric parameters with artificial neural network over Antarctic region using Ku-Band based ISRO's SCATSAT-1 data. In 2021 IEEE International Geoscience and Remote Sensing Symposium IGARSS (pp. 435-438). IEEE.",
      },
      {
        title:
          "Gaikwad, D., Guha, S. and Tiwari, R.K., (2021) “Estimation of Expansion rate of Glacial Lake in Sikkim Himalayas using Nonparametric Statistical Testing Techniques”, 1st Mediterranean Geosciences Union Annual Meeting, Springer, Istanbul, Turkey, 22-25 November, 2021 (Accepted).",
      },
      {
        title:
          "Ganguly S, H. Puppala. Investigation of the Potential and Thermal Performance of a Proposed Aquifer Thermal Energy Storage System at Ropar, India. World Geothermal Congress 2020+1, Reykjavik, Iceland (May 2021).",
      },
      {
        title:
          "Prashanth T, Ganguly S. Hydrological modeling for Sutlej basin using SWAT. Hydro 2021 International, SVNIT Surat, India. Dec 2021.",
      },
      {
        title:
          "Ganguly S and Ganguly S. Numerical modelling of transport and fate of Chromium (VI) in sub-surface porous media. Hydro 2021 International, SVNIT Surat, India. Dec 2021. (Best paper presentation award for Shreya Ganguly).",
      },
    ],

    bookdata: [
      {
        title:
          "Tyagi, A, Tiwari, R. K. and James, N. (2021), “GIS-Based Landslide Hazard Zonation and Risk Studies Using MCDM” In Local Site Effects and Ground Failures. PP 251.",
      },
      {
        title:
          "Tripathi, A. and Tiwari R.K. (2021) “Role of Space-Borne Remote Sensing Technology for Monitoring of Urban and Environmental Hazards” in Recent Technologies for Disaster Management and Risk Reduction. (Accepted)",
      },
      {
        title:
          "Singh, S., Tiwari, R. K., Sood, V., & Prashar, S. (2021). Unsupervised Snow Cover Classification Using Dual-Polarized SCATSAT-1 Satellite Data. In Soft Computing and Signal Processing (pp. 627-635). Springer, Singapore.",
      },
      {
        title:
          "Singh D.K., Gusain H.S., Dewali S.K., Tiwari R.K., Taloor A.K. (2021) Analysis of Snow Dynamics in Beas River Basin, Western Himalaya Using Combined Terra–Aqua MODIS Improved Snow Product and in Situ Data During Twenty-First Century. In: Taloor A.K., Kotlia B.S., Kumar K. (eds) Water, Cryosphere, and Climate Change in the Himalayas. Geography of the Physical Environment. Springer, Cham. https://doi.org/10.1007/978-3-030-67932-3_7.",
      },
    ],

    journaldata: [
      {
        title:
          "Chvan, S. R., and Srinivas, V. V. (2021). Evaluation of three approaches to probable maximum precipitation estimation: a study on two Indian river basins. Theoretical and Applied Climatology, 1-19 (Impact factor: 3.4 and Q2 journal).",
      },
      {
        title:
          "Shobhit Maheshwari and Chavan, S.R., (2021) Evaluation of approaches to estimate discharge indices based on mean sediment load for suspended sediment transport in South Indian catchments, International Journal of River Basin Management, 21:2,339-355, DOI: 0.1080/15715124.2021.2000426. (Impact factor: 2.5 and Q2 journal).",
      },
      {
        title:
          "Gupta, N., & Chavan, S. R. (2021). Characterizing the tail behaviour of daily precipitation probability distributions over India using the obesity index. International Journal of Climatology, 42(4), pp.2543-2565. https://doi.org/10.1002/joc.7380. (Impact factor: 4.069 and Q1 journal).",
      },
      {
        title:
          "Gupta, N. and Chavan, S.R., (2021). Assessment of temporal change in the tails of probability distribution of daily precipitation over India due to climatic shift in the 1970s. Journal of Water and Climate Change, 12(6), pp.2753-2773, https://doi.org/10.2166/wcc.2021.008. (Impact factor: 2.8 and Q2 journal).",
      },
      {
        title:
          "Sankaran, A., Chavan, S. R., Ali, M., Sindhu, A. D., Dharan, D. S., & Khan, M. I. (2021). Spatiotemporal variability of multifractal properties of fine resolution daily gridded rainfall fields over India. Natural Hazards, 1-29, https://doi.org/10.1007/s11069-021-04523-0. (Impact factor: 3.7 and Q1 journal).",
      },
      {
        title:
          "Aaditya, Bh., Rahul, T.M, 2021. Psychological impacts of COVID-19 pandemic on the mode choice behaviour: A hybrid choice modelling approach. Transport Policy 108, 47-58 (Elsevier).",
      },
      {
        title:
          "Aaditya,Bh., Rahul,T.M, 2021.A comprehensive analysis of the trip frequency behavior in COVID scenario. Transportation Letters 13, 395-403 (Taylor & Francis).",
      },
      {
        title:
          "Rahul, T.M., Manoj, M., Tahlyan, D., Verma, A., 2021.The influence of activities and socio economic/ demographic factors on the acceptable distance in an Indian scenario, Transportation in Developing Economies 7(3) (Taylor & Francis).",
      },
      {
        title:
          "Raheena, M. and Robinson, R. G. (2021). Inflection point method for faster and complete consolidation testing. Geotechnique, 71(7): 645-654, Thomas Telford Ltd (Impact factor 6.3).",
      },
      {
        title:
          "Surana M, Singh Y and Lang DH (2021). Damping Modification Factors Observed from the Indian Strong-motion Database, Journal of Earthquake Engineering, 25(13), 2758-2773, DOI: https://doi.org/10.1080/13632469.2019.1643809.",
      },
      {
        title:
          "Surana M, Singh Y and Lang DH (2021). Effect of Structural Characteristics on Damping Modification Factors for Floor Response Spectra in RC Buildings, Engineering Structures, 242, DOI:https://doi.org/10.1016/j.engstruct.2021.112514.",
      },
      {
        title:
          "Tripathi, A., Attri, L., & Tiwari, R. K. (2021). Spaceborne C-band SAR remote sensing–based flood mapping and runoff estimation for 2019 flood scenario in Rupnagar, Punjab, India. Environmental Monitoring and Assessment, 193(3), 1-16. (Q2).",
      },
      {
        title:
          "Tripathi, A., & Tiwari, R. K. (2021). A simplified subsurface soil salinity estimation using synergy of SENTINEL-1 SAR and SENTINEL-2 multispectral satellite data, for early stages of wheat crop growth in Rupnagar, Punjab, India. Land Degradation & Development, 32 (14), 3905–3919. https://doi.org/10.1002/ldr.4009 (Q1).",
      },
      {
        title:
          "Tripathi, A. & Tiwari, R. K. (2021). Utilization of Spaceborne C-band dual Pol Sentinel-1 SAR data for simplified Regression-based Soil Organic Carbon Estimation in Rupnagar, Punjab, India. Advances in Space Research, https://doi.org/10.1016/j.asr.2021.08.007 (Q1).",
      },
      {
        title:
          "Singh, S., Tiwari, R.K., Sood, V. & Prashar, S. (2021) Fusion of SCATSAT-1 and optical data for cloud-free imaging and its applications in classification. Arabian Journal of Geosciences 14, 1978. https://doi.org/10.1007/s12517-021-08359-7 (Q2).",
      },
      {
        title:
          "Singh, S., Tiwari, R. K., Sood, V., Kaur, R. & Prashar, S. (2021). The Legacy of Scatterometers: Review on Applications and Perspective. IEEE Geoscience and Remote Sensing Magazine. DOI: 10.1109/MGRS.2022.3145500. (Q1).",
      },
      {
        title:
          "Singh, S., Tiwari, R. K., Sood, V., Gusain, H. & Prashar, S. (2021). Image-Fusion of Ku-band based SCATSAT-1 and MODIS data for Cloud-free Change Detection over Western Himalayas. IEEE Transactions on Geoscience and Remote Sensing. vol. 60, pp. 1-14, 2022, Art no. 4302514, doi: 10.1109/TGRS.2021.3123392. (Q1).",
      },
      {
        title:
          "Singh, N., Singh, J., Gupta, A. K., Bräuning, A., Dimri, A.P., Ramanathan, A.L., Sharma, V., Tiwari, R. K., Chakraborty, J. S., Chauhan, P., Shukla, T., Singhal, M., Rawat, R., Agarwal, S., and Raja, P., (2021) “Climate-driven acceleration in forest evapotranspiration fueling extreme rainfall events in the Himalayas. Environmental Research Letters, 16(8), 084042. https://doi.org/10.1088/1748-9326/ac14ed (Corresponding Author). (Q1).",
      },
      {
        title:
          "Singh, S., Tiwari, R. K., Sood, V., & Gusain, H. S. (2021). Detection and validation of spatiotemporal snow cover variability in the Himalayas using Ku-band (13.5 GHz) SCATSAT-1 data. International Journal of Remote Sensing, 42(3), 805-815. (Q1).",
      },
      {
        title:
          "Kumar, S., Sonkar, I., Gupta, V., Hari Prasad, K. S., & Ojha, C. S. P. (2021). Effect of Salinity on Moisture Flow and Root Water Uptake in Sandy Loam Soil. Journal of Hazardous, Toxic, and Radioactive Waste, 25(3). https://doi.org/10.1061/(ASCE)HZ.2153-5515.0000618",
      },
      {
        title:
          "Ganguly S and Ganguly S. Implementation of Managed Aquifer Recharge Techniques in India. Current Science (SCI). Vol. 121(5), Sep 2021. pp. 641-650.",
      },
      {
        title:
          "Ganesh, R., and J. P. Sahoo. 2021. Vertical uplift capacity of rectangular and square plate anchors in granular soil under seismic forces. Journal of Earthquake Engineering, Taylor Francis Ltd, England. 26(14), 7366–7383. Impact Factor: 2.997/2021. https://doi.org/10.1080/13632469.2021.1964641.",
      },
      {
        title:
          "Ganesh, R., J. P. Sahoo, and S. Rajesh. 2021. Passive resistance of unsaturated backfill under steady state flow conditions. Geomechanics and Geoengineering, Taylor Francis Ltd, United Kingdom. 17(5), 1653–1669. https://doi.org/10.1080/17486025.2021.1955163",
      },
      {
        title:
          "Ganesh, R., and J. Kumar. 2021. Ultimate bearing capacity of strip and circular foundations using power type yield criterion using the method of stress characteristics. Computers and Geotechnics, Elsevier Sci Ltd, England. 133, 104066. Impact Factor: 5.218/2021. https://doi.org/10.1016/j.compgeo.2021.104066",
      },
      {
        title:
          "Ganesh, R., S. Khuntia, and J. P. Sahoo. 2021. Active thrust of sand with anisotropic seepage: a generalised limit equilibrium approach. Proceedings of the Institution of Civil Engineers-Geotechnical Engineering, ICE Publishing, England. 175(5), 495-506. Impact Factor: 1.953/2021. https://doi.org/10.1680/jgeen.20.00071",
      },
    ],
  },

  2022: {
    conferencedata: [
      {
        title:
          "U., Veena and Naveen James (2022). Natural Rubber Latex for Reducing Soil Brittleness Induced by Post-Compaction Moisture Reduction, Indian Geotechnical Conference (IGC)-2022",
      },
      {
        title:
          "Aaditya, Bh., Rahul, T.M., (2022). Systematic analysis of measurement errors in discrete choice models - A hybrid choice modelling approach, International conference on Choice Modelling 2022",
      },
      {
        title:
          "Modha, K., Surana, M., Nath, K., Shastri, R., Haldar, P., Raj D., Prakash, S., Bhardwaj, A. and Singh, Y. (2022). Seismic Risk Assessment of a Himalayan Town: A Case Study of Queen of Hills, Mussoorie, Uttarakhand, India, 17th Symposium on Earthquake Engineering, Department of Earthquake Engineering, IITRoorkee, November 17-19, 2022",
      },
      {
        title:
          "Naveen James, Manoj Kannan, Rajamanickam and Putul Haldar (2022). Effect of Soil Structure Interaction on Collapse Behaviour of RC Buildings with Shear Wall, Two days’ symposium on Socio-Technological Aspects of Seismic Disaster and Mitigation (STASDM), June 23-24, 2022, IIT Guwahati, India",
      },
      {
        title:
          "Onkar Mishra, Putul Haldar, Amar Nath Roy Chowdhury (2022). Comparative Study of Computational Modelling Frameworks for Structural Assessment of Reinforced Concrete Beam, Proceedings of 17th Symposium on Earthquake Engineering, Department of Earthquake Engineering, IITRoorkee, November 17-19, 2022",
      },
      {
        title:
          "Anushi Narula, Vishal, Vishal, Putul Haldar, Surinder Deswal, Indramani Dhada (2022). Associated Health Risk of TVOCs and Criteria Pollutants in a Cluster of Industries: a Case Study, 3rd International Conference on Advanced Technologies for Industrial Pollution Control (ATIPC-2022), IIEST Shibpur, December 21-23, 2022",
      },
      {
        title:
          "Vishal, Anushi Narula, Indramani Dhada, Putul Haldar, Chirodeep Bakli (2022). Health Risk of Black Carbon and correlation with lung function test, 3rd International Conference on Advanced Technologies for Industrial Pollution Control (ATIPC-2022), IIEST Shibpur, December 21-23, 2022",
      },
      {
        title:
          "Mitkari, K. V., Arora, M. K., Sofat, S. and Tiwari, R. K., (2022). Effect of Pixel Size and Window Size on the Accuracy of Remote Sensing Based Glacier Velocity Measurement: A Case Study of Gangotri Glacier, Indian Himalayas, International Symposium on Ice, Snow and Water in a Warming World, Reykjavík, Iceland, 21-26 August 2022",
      },
      {
        title:
          "Mitkari, K. V., Sofat, S., Arora, M. K. and Tiwari, R. K., (2022). Extraction of Debris Covered Glacier Features using Object Based Image Analysis Paradigm, International Mountain Conference 2022, Innsbruck, Austria, 11-15 September 2022",
      },
      {
        title:
          "Singh, S., Tiwari, R. K. and V. Sood. (2022). Estimation of landcover types over Himalayan region with the classification of optical and microwave-based image fusion dataset, The International Archives of the Photogrammetry, Remote Sensing and Spatial Information Sciences 43 (2022): 523-528",
      },
      {
        title:
          "Singh, S., Tiwari, R.K., Sood, V. and Prashar, S., (2022). Current status of the ISRO’s SCATSAT-1 mission, products, utilisation and future enhancements, AIP Conference Proceedings (Vol. 2451, No. 1), October 2022",
      },
      {
        title:
          "Vishal, Dhada I, Haldar P, Bakli C (2022). Health Risk of Black Carbon Found in Industrial Cluster of Chandigarh and Its Correlation with Lung Function Test, 3rd International Conference on Advanced Technologies for Industrial Pollution Control (ATIPC-2022) December 21-23, Kolkata",
      },
      {
        title:
          "Narula A, Vishal, Haldar P, Deswal S, Dhada I (2022). Associated Health Risk of TVOCs and Criteria Pollutants in a Cluster of Industries: a Case Study, 3rd International Conference on Advanced Technologies for Industrial Pollution Control (ATIPC-2022) December 21-23, Kolkata",
      },
      {
        title:
          "Bhatia S, Raj B.P & Dhada I (2022). Exposure of students of Educational Institute to Indoor Air Pollutants: IIT Ropar a case study, International Conference on Environmental Science and Engineering (ICESE 2022) Environmental Science and Engineering Department, Indian Institute of Technology Bombay",
      },
      {
        title:
          "Prashanth T, Ganguly S and Banerjee D. (2022). Mapping areas suitable for artificial recharge structures in the Ropar District of Punjab, India, European Geosciences Union (EGU) General Assembly 2022 abstracts. Vienna, Apr 2022",
      },
      {
        title:
          "Ganguly S and Ganguly S. (2022). Adsorption of Chromium (VI) by soil sediments in heterogeneous porous media: a case study in Rupnagar district of Punjab, India, European Geosciences Union (EGU) General Assembly 2022 abstracts. Vienna, Apr 2022",
      },
      {
        title:
          "Prashanth T, Ganguly S, Gummadi M. (2022). Prioritizing areas prone to critical soil erosion by using Multiple Criteria Decision Analysis and GIS techniques, International Conference on River Corridor Research and Management, IIT Guwahati, India, May 30-June 1, 2022",
      },
      {
        title:
          "Goswami R, Das, R and Ganguly S. (2022). Economic and Feasibility Study of Biomass-Based Electric Power Generation, The 15th Regional Conference on Energy Engineering And The 13th International Conference on Thermofluids 2022, University of Gadjah Mada, Indonesia, Oct 2022",
      },
      {
        title:
          "Goswami R, Das, R and Ganguly S. (2022). Experimental Investigation on Electric Power Generation by Harvesting Biomass Waste-heat using Thermoelectric Array, The 3rd International Recent Trends in Engineering, Advanced Computing and Technology Conference 2022, Jeddah, Saudi Arabia, Nov 2022",
      },
      {
        title:
          "Ganguly S and Ganguly S. (2022). Removal of Hexavalent Chromium by using natural soil-chitin-magnetite nanoparticles composite: A preliminary investigation, American Geophysical Union (AGU) Fall Meeting 2022 abstract. Chicago, 14th Dec 2022",
      },
      {
        title:
          "Prashanth T and Ganguly S, Dhote P.R. (2022). Perenniality Analysis of the Godavari River, India by Using River Perenniality Index, American Geophysical Union (AGU) Fall Meeting 2022 abstract. Chicago, 15th Dec 2022",
      },
      {
        title:
          "Banerjee D and Ganguly S. (2022). Forecasting future groundwater recharge in California State, USA using deep learning techniques, American Geophysical Union (AGU) Fall Meeting 2022 abstract. Chicago, 15th Dec 2022",
      },
      {
        title:
          "Jaiswal, M., Sebastian, R., & Mulaveesala, R (2022). Numerical simulation study on subsurface microcrack using active infrared thermography, Indian Geotechnical Conference (IGC-2022), Kochi, 15-17 December 2022",
      },
      {
        title:
          "Saha, K & Sebastian, R (2022). Comparison of joint models used for the propagation of shear waves across jointed rocks, Indian Geotechnical Conference (IGC-2022), Kochi, 15-17 December 2022",
      },
      {
        title:
          "Sakshi, R & Sebastian, R (2022). Influence of density on the dynamic properties of intact rocks, Indian Geotechnical Conference (IGC-2022), Kochi, 15-17 December 2022",
      },
      {
        title:
          "Ratan Sarmah, Ickkshaanshu Sonkar and Sagar Rohidas Chavan (2022). Analytical solutions for predicting seepage in a layered ditch drainage system under Dirichlet and lagging Robin boundary conditions, Hydrological Sciences Journal 67(13), 1917-1940",
      },
    ],

    bookdata: [
      {
        title:
          "A Review of Seismic Safety Measures for the Construction of New Stone Masonry Houses, Proceedings of 17th Symposium on Earthquake Engineering",
      },
      {
        title:
          "Seismic Performance of Different Typologies of Stone Masonry Houses in India, Proceedings of 17th Symposium on Earthquake Engineering",
      },
      {
        title:
          "Seismic Retrofitting of Existing Stone Masonry Houses: An Overview, Proceedings of 17th Symposium on Earthquake Engineering",
      },
      {
        title:
          "Effectiveness of Friction Pendulum System in Controlling Structural and Non-structural Responses of Short-Period Reinforced-concrete Buildings at Near-Fault Sites, Proceedings of 17th Symposium on Earthquake Engineering",
      },
      {
        title:
          "Seismic Risk Assessment of a Himalayan Town: A Case Study of Queen of Hills, Mussoorie, Uttarakhand, India, Proceedings of 17th Symposium on Earthquake Engineering",
      },
      {
        title:
          "Peculiarities of Seismic Risk in Hilly Regions: Topographic Effects on Hazard and Vulnerability, 3rd European Conference on Earthquake Engineering and Seismology",
      },
      {
        title:
          "Effect of the Damping Ratio of Non-structural Components on Floor Acceleration Demands in Torsionally Irregular Buildings, 8th ECCOMAS Thematic Conference on Computational Methods in Structural Dynamics and Earthquake Engineering (COMPYDYN 2021 Vol. II)",
      },
      {
        title:
          "Effect of Supporting Structure’s Torsion on Floor Acceleration Demands in Buildings on Slopes, Recent Advances in Earthquake Engineering, Virtual Conference on Disaster Risk Reduction – Civil Engineering for a Disaster Resilient Society",
      },
      {
        title:
          "Kurmi P.L., Haldar P. (2022), Effect of Revised Seismic Design Provisions on Seismic Performance of RC Frame Buildings with and Without Infills, CIGOS 2021, Emerging Technologies and Applications for Green Infrastructure, Lecture Notes in Civil Engineering-book series, vol. 203, pp 137-145. Springer, Singapore. https://doi.org/10.1007/978-981-16-7160-9_13",
      },
      {
        title:
          "Reddy K.K.K., Haldar P. (2022), Effect of Structural Wall Plan Density on Performance of RC Shear Wall Buildings Designed as Per Indian Standards, CIGOS 2021, Emerging Technologies and Applications for Green Infrastructure, Lecture Notes in Civil Engineering-book series, vol. 203, pp 157-165. Springer, Singapore. https://doi.org/10.1007/978-981-16-7160-9_15",
      },
      {
        title:
          "Kurmi P., Haldar P. (2022), Simplified Macro Modeling Approach for Estimation of Nonlinear Response of Infilled RC Frames, Recent Advances in Earthquake Engineering, Lecture Notes in Civil Engineering-book series, vol. 175, pp 451-464. Springer, Singapore. https://doi.org/10.1007/978-981-16-4617-1_36",
      },
      {
        title:
          "Gaikwad, D., Guha, S., & Tiwari, R. K. (2022). Monitoring Spatiotemporal Patterns of Glacial Lakes in the Eastern Himalayas Using Satellite Data and Nonparametric Statistical Testing Techniques, Handbook of Himalayan Ecosystems and Sustainability, Volume 2 (pp. 35-51). CRC Press",
      },
      {
        title:
          "Kaur, R., Tiwari, R. K., Maini, R., Singh, S., & Sood, V. (2022). The study of Indian Space Research Organization's Ku-band based scatterometer satellite (SCATSAT-1) in agriculture: applications and challenges, Radar Remote Sensing, 389-404",
      },
      {
        title:
          "Rajesh, S., and R. Ganesh. (2022). Analytical solution for the action of seismic active earth pressures of unsaturated backfills behind inclined walls, Earthquake Geotechnics, Lecture Notes in Civil Engineering, vol 187, 17-32. Springer, Singapore. ISBN 978-981-16-5669-9. https://doi.org/10.1007/978-981-16-5669-9_2",
      },
    ],

    journaldata: [
      {
        title:
          "Ankit Tyagi, Reet Kamal Tiwari and Naveen James (2022). Mapping the landslide susceptibility considering future land-use land-cover scenario. Landslides, 19(10), DOI 10.1007/s10346-022-01968-7.",
      },
      {
        title:
          "U., Veena and Naveen James (2022). Natural Rubber Latex for Improving Ductility Characteristics of Soil: A Preliminary Experimental Investigation. Geotechnical and Geological Engineering, 40 (6). https://doi.org/10.1007/s10706-022-02162-1.",
      },
      {
        title:
          "Ankit Tyagi, Reet Kamal Tiwari and Naveen James (2022). A Review on Spatial, Temporal and Magnitude Prediction of Landslide Hazard. Journal of Asian Earth Sciences: X, 7(1), https://doi.org/10.1016/j.jaesx.2022.100099.",
      },
      {
        title:
          "Maheshwari, S. and Chavan, S.R., (2022). A modified approach to determine suspended sediment transport effectiveness in Indian rivers. Journal of Hydrology, 605, p.127284 (Impact factor: 6.4 and Q1 journal)",
      },
      {
        title:
          "Rana, S., Deoli, V., and Chavan, S. R. (2022). Detection of abrupt change in trends of rainfall and rainy day’s pattern of Uttarakhand. Arabian Journal of Geosciences, 15(7), 1-17 (Impact factor: .406 and Q2 journal).",
      },
      {
        title:
          "Chavan, S. R., and Gupta, N. (2022). On Investigation of Magnitude and Frequency of Annual Maximum Daily Precipitation in the Catchment of Bhakra Dam. INCOLD Journal (A Half Yearly Technical Journal of Indian Committee on Large Dams), 11(2), 18-28.",
      },
      {
        title:
          "Amini SN and Rajput AS; Effect of Corrosion Location and Transverse Reinforcement on Flexural-Ductile Response of Reinforced Concrete Beams, International Journal of Civil Infrastructure, Vol 05, Year 2022, pp 104-114, DOI: https://doi.org/10.11159/ijci.2022.014.",
      },
      {
        title:
          "Niraj Janardhan Sahare and Raheena M (2022). Application of genetic programming in the field of geotechnical engineering - a review. Indian Geotechnical Conference at Kochi.",
      },
      {
        title:
          "Raheena, M. and Robinson, R. G. (2022). Determining the Strain Rate of Controlled-Strain Loading Consolidation Test with hydraulic conductivity. Canadian Geotechnical Journal doi.org/10.1139/cgj-2022-0351 (Impact factor 4.3).",
      },
      {
        title:
          "Raheena, M. and Robinson, R. G. (2022). One-dimensional Consolidation Test with Pore Pressure Measurements – an Accelerated Procedure. Geotechnical Testing Journal, ASTM doi.org/10.1520/GTJ20220098. (Impact factor 1.5).",
      },
      {
        title:
          "Surana M, Ghosh A, Baldev D (2022). Seismic Features and Vulnerability of Traditional Buildings in the State of Himachal Pradesh, India, Journal of Building Engineering, 62, DOI: https://doi.org/10.1016/j.jobe.2022.105376.",
      },
      {
        title:
          "Latif I, Banerjee A and Surana M (2022). Explainable Machine Learning Aided Optimization of Masonry Infilled Reinforced Concrete Frames, Structures, 44, 1751-1766, DOI: https://doi.org/10.1016/j.istruc.2022.08.115.",
      },
      {
        title:
          "Jain A and Surana M (2022). Floor-Displacement Based Torsional Amplification Factors for Seismic Design of Acceleration-Sensitive Non-structural Component in Torsionally Irregular Buildings, Engineering Structures, 254, DOI: https://doi.org/10.1016/j.engstruct.2022.113871.",
      },
      {
        title:
          "Panna Lal Kurmi, and Putul Haldar*, (2022), Modeling of Opening for Realistic Assessment of Infilled RC Frame Buildings, Structures, Vol. 41, July 2022, Pages 1700-1709. https://doi.org/10.1016/j.istruc.2022.05.110.",
      },
      {
        title:
          "Guha, S., & Tiwari, R. K. (2022). Analysis of differential glacier behaviour in Sikkim Himalayas in view of changing climate. Geocarto International, 1-23.",
      },
      {
        title:
          "Mitkari, K. V., Arora, M. K., Tiwari, R. K., Sofat, S., Gusain, H. S., & Tiwari, S. P. (2022). Large-scale debris cover glacier mapping using multisource object-based image analysis approach. Remote Sensing, 14(13), 3202.",
      },
      {
        title:
          'Tripathi, A., Reshi, A. R., Moniruzzaman, M., Rahaman, K. R., Tiwari, R. K. and Malik, K., (2022). "Interoperability of C-band Sentinel-1 SAR and GRACE satellite sensors on PSInSAR based urban surface subsidence mapping of Varanasi, India," in IEEE Sensors Journal, 2022, doi: 10.1109/JSEN.2022.3208117.',
      },
      {
        title:
          "Sood, V., Tiwari, R. K., Singh, S., Kaur, R., & Parida, B. R. (2022). Glacier boundary mapping using deep learning classification over Bara Shigri Glacier in Western Himalayas. Sustainability, 14(20), 13485.",
      },
      {
        title:
          "Singh, S., Tiwari, R.K., Sood, V., Kaur, R., Singh, S. and Prashar, S., 2022. Estimation and validation of standalone SCATSAT-1 derived snow cover area using different MODIS products. Geocarto International, 37(27), pp.18474-18490.",
      },
      {
        title:
          "Tripathi, A., & Tiwari, R. K. (2022). Synergetic utilization of sentinel-1 SAR and sentinel-2 optical remote sensing data for surface soil moisture estimation for Rupnagar, Punjab, India. Geocarto International, 37 (8), 2215-2236. (Q1)",
      },
      {
        title:
          "Reshi, A. R., Moniruzzaman, M., Tripathi, A., Tiwari, R. K., & Rahaman, K. R. (2022). A remote sensing based study of tropospheric ozone concentration amid COVID-19 lockdown over India using Sentinel-5P satellite data. Geocarto International, 1-20. DOI:10.1080/10106049.2022.2123957.",
      },
      {
        title:
          "Pandey, A. C., Ghosh, T., Parida, B. R., Dwivedi, C. S., & Tiwari, R. K. (2022). Modeling Permafrost Distribution Using Geoinformatics in the Alaknanda Valley, Uttarakhand, India. Sustainability, 14(23), 15731.",
      },
      {
        title:
          "Singh N, Shekhar M, Parida BR, Gupta AK, Sain K, Rai SK, Bräuning A, Singh Charkaborty J, Sharma V, Tiwari R. K., Chauhan P and Montagnani L (2022). Tree-Ring Isotopic Records Suggest Seasonal Importance of Moisture Dynamics Over Glacial Valleys of the Central Himalaya. Front. Earth Sci. 10:868357. doi: 10.3389/feart.2022.868357 (Q1)",
      },
      {
        title:
          "Tyagi, A., Tiwari, R. K., & James, N. (2022). A Review on Spatial, Temporal and Magnitude Prediction of Landslide Hazard. Journal of Asian Earth Sciences: X, 100099.",
      },
      {
        title:
          "Tripathi, A., Tiwari, R. K., & Tiwari, S. P. (2022). A deep learning multi-layer perceptron and remote sensing approach for soil health-based crop yield estimation. International Journal of Applied Earth Observation and Geoinformation, 113, 102959.",
      },
      {
        title:
          "Pasupuleti, S., Singha, SS., Singha, S., Kumar, S., Singh, R., & Dhada, I. (2022). Groundwater characterization and non-carcinogenic and carcinogenic health risk assessment of nitrate exposure in the Mahanadi River Basin of India, Journal of Environmental Management, 319, 115746.",
      },
      {
        title:
          "Sarmah, R., Sonkar, I., & Chavan, S. R. (2022). Analytical solutions for predicting seepage in a layered ditch drainage system under Dirichlet and lagging Robin boundary conditions. Hydrological Sciences Journal, 67(13), 1917–1940. https://doi.org/10.1080/02626667.2022.2101891",
      },
      {
        title:
          "Sonkar, I., Sudesan, S., & Suryanarayana Rao Kotnoor, H. P. (2022). Compensated non‐linear root water uptake model and identification of soil hydraulic and root water uptake parameters. Irrigation and Drainage, 71(1), 157–174. https://doi.org/10.1002/ird.2636",
      },
      {
        title:
          "Das R and Ganguly S. (2022). A Comprehensive Review on Solar Pond Research in India: Past, Present and Future. Solar Energy (Elsevier) (SCI). Vol. 247, Nov 2022. pp. 55-72.",
      },
      {
        title:
          "Development of entropy and deviation-based water quality index: Case of river Ganga, India. M Verma, VA Loganathan & VK Bhatt. Ecological Indicators. 2022; 143.109319.",
      },
      {
        title:
          "Assessment of traditional rainwater harvesting system in barren lands of a semi-arid region: A case study of Rajasthan (India). Basant Yadav, Nitesh Patidar, Anupma Sharma, Niranjan Panigrahi, Rakesh K Sharma, V Loganathan, Gopal Krishan, Jaswant Singh, Suraj Kumar, Alison Parker. Journal of Hydrology: Regional Studies.2022. Volume 42. Pages 101149.",
      },
      {
        title:
          "Ganesh, R., and J. Kumar. (2022). Seismic bearing capacity of strip foundations with nonlinear power-law yield criterion using the stress characteristics method. Journal of Geotechnical and Geoenvironmental Engineering, ASCE. 148(11), 04022083–1–13. Impact Factor: 4.600/2021. https://doi.org/10.1061/(ASCE)GT.1943-5606.0002867",
      },
      {
        title:
          "Ganesh, R., and S. Rajesh. (2022). Coupled effect of suction stress and unit weight on the active earth pressure of unsaturated backfills. International Journal of Geomechanics, ASCE. 22(8),06022018. Impact Factor: 3.918/2021. https://doi.org/10.1061/(ASCE)GM.1943-5622.0002449",
      },
      {
        title:
          "Ratan Sarmah, Ickkshaanshu Sonkar and Sagar Rohidas Chavan (2022). Analytical solutions for predicting seepage in a layered ditch drainage system under Dirichlet and lagging Robin boundary conditions. Hydrological Sciences Journal 67(13), 1917-1940.",
      },
    ],
  },

  2023: {
    conferencedata: [
      {
        title:
          "U., Veena and Naveen James (2023). Application of Natural Rubber Latex for Improving Dynamic Response of Sand, ASCE INSPIRE 2023 Conference, Arlington, Virginia.",
      },
      {
        title:
          "Gupta, N., & Chavan, S. R. (2023, May). Assessing daily precipitation tails over India under changing climate. In EGU General Assembly Conference Abstracts (pp. EGU-13328).",
      },
      {
        title:
          "Rana, S., & Chavan, S. R. (2023, May). Design Flood estimation based on Equivalent Geomorphological Instantaneous Unit Hydrograph for a Himalayan catchment. In EGU General Assembly Conference Abstracts (pp. EGU-13139).",
      },
      {
        title:
          "Kaur, S., & Chavan, S. R. (2023). Assessing impacts of spatio-temporal changes in land use and land cover on the hydrologic response of an Indian Catchment (No. EGU23-14603). Copernicus Meetings.",
      },
      {
        title:
          "Lall, R., & Chavan, S. R. (2023). Design Flood Estimation based on Synthetic Unit Hydrograph Method for an Indian catchment (No. EGU23-15084). Copernicus Meetings.",
      },
      {
        title:
          "Singh, A., & Chavan, S. R. (2023). Design flood estimation for ungauged catchments in Krishna River Basin using a transformation-based approach to Regional Flood Frequency Analysis (No. EGU2313415). Copernicus Meetings.",
      },
      {
        title:
          "Amini SN and Rajput AS; Effect of Corrosion and Transverse Reinforcement on Flexural Response of 3D Finite Element Reinforced Concrete Beams, Proceedings of the 7th International Conference on Civil Structural and Transportation Engineering (ICCSTE'22) Niagara Falls, Canada – June 05-07, 2022, DOI: 10.11159/iccste22.225.",
      },
      {
        title:
          "Amini SN and Rajput AS; Capacity Assessment of Corroded Reinforced Concrete Structures: from Research to Daily Engineering Evaluation', CACRCS-2023, September 13-15, 2023, University of Parma, Italy.",
      },
      {
        title:
          "Johri S, Amini SN, and Rajput AS; International Conference on Condition Assessment, Rehabilitation; Retrofitting of Structures, CARRS-2023, December 10-13, 2023, IIT Hyderabad.",
      },
      {
        title:
          "Ahmad, Hafsoah, Rahul, T.M., 2023. Socio-demographic determinants of electric vehicle purchase intention in emerging markets: evidence from urban Punjab, India. 7th Conference of Transportation Research Group of India, Surat, India.",
      },
      {
        title:
          "Aaditya, Bh., Rahul, T.M., Asija, Navdeep, 2023. Using urban topology to identify critical links of the road network: a Centrality based approach, 16th Urban Mobility India Conference cum Exhibition 2023, Delhi, India.",
      },
      {
        title:
          "Latif I, Surana M and Banerjee A (2023). MARCS: Machine Learning for Seismic Performance Prediction of RC Buildings on Slopes, 18th World Conference on Earthquake Engineering, Milan, Italy. (Submitted).",
      },
      {
        title:
          "Jain A, and Surana M (2023). Effects of Building Torsion on Seismic Response of Acceleration-Sensitive Non-Structural Components, 18th World Conference on Earthquake Engineering, Milan, Italy. (Submitted).",
      },
      {
        title:
          "Zimmy Singh Naorem, Putul Haldar (2023), 'Effect of Seismic Design Provisions of Indian Standards on Seismic Response of URM Infilled RC Step-Back Building on Hill', International Conference on Vibration Problems, 05 - 09 February 2023 at Doha – Qatar. (Won best paper award).",
      },
      {
        title:
          "K. K. K. Reddy*, and P. Haldar (2023), 'Effect of Foundation Flexibility on Seismic Behaviour of Reinforced Concrete Shear Wall Buildings', Proceedings of the 6th International Conference on Civil Engineering for Sustainable Development (ICCESD 2022), 10~12 February 2022, KUET, Khulna, Bangladesh. AIP Conference Proceedings vol. 2713, Issue. 1, 020018 (2023) https://doi.org/10.1063/5.0129723.",
      },
      {
        title:
          "Tiwari, R.K., James, N. and Suresh, K. Aravind (2023, Nov.) Fusion of UAV and TLS Data for the generation of Digital Terrain Models and its application in Slope Stability analysis. Paper presented in UASG 2023, Kuala Lampur.",
      },
      {
        title:
          "Sood, V., Tiwari, R.K. and Singh, S., (2023, July) Super-resolution Snow-cover Mapping of Ku-Band based ISRO’s SCATSAT-1 Data using Spectral Mixture Analysis. In IGARSS 2023-2023 IEEE International Geoscience and Remote Sensing Symposium (pp. 129-132). IEEE.",
      },
      {
        title:
          "Singh, S., Tiwari, R.K. and Sood, V., (2023, July) Role of Ku-band (13.5 GHz) based Scatterometer Satellite (SCATSAT-1) in Cryospheric applications. In IGARSS 2023-2023 IEEE International Geoscience and Remote Sensing Symposium (pp. 137-140). IEEE.",
      },
      {
        title:
          "Mitkari, K. V., Sofat, S., Arora, M. K. and Tiwari, R. K. (2023). 'Linking Changes in Gangotri Glacier Features Derived at a Large-Scale with Climate Variability', EGU General Assembly 2023, Vienna, Austria, 24–28 April 2023, EGU23-252.",
      },
      {
        title:
          "Goet, G., Sonkar, I. and Prasad, K.H., 2023. Genetic Algorithm for Estimating Non-linear Parameters in Root Water Uptake Model: A Model-Linkage Approach. AGU23.",
      },
      {
        title:
          "Goet, G., Sonkar, I. and Prasad, K.H., 2023. Estimation of Non-Linear Water Uptake Parameter using Genetic Algorithm for Sodic Soils. EGU23.",
      },
      {
        title:
          "Sonkar, I. and Prasad, K. S. H., 2018. Root Zone Modeling Under Water Stressed Condition Using Compensated Nonlinear Root Water Uptake Model, AGU18.",
      },
      {
        title:
          "Banerjee D and Ganguly S. Predicting future groundwater recharge scenario in the Punjab region of India using machine learning techniques. European Geophysical Union (EGU) General Assembly 2023 abstract. 26th Apr 2023.",
      },
      {
        title:
          "Ganguly S and Ganguly S. Adsorption of Hexavalent Chromium by Magnetite Nanoparticles Synthesized at Various Temperatures: Effect of Magnetic Properties of the nanoparticles on individual Adsorption Mechanisms. European Geosciences Union (EGU) General Assembly 2023 abstract. Vienna. 27th Apr 2023.",
      },
      {
        title:
          "Prashanth T and Ganguly S. Analyzing the behavioural changes of various fluvial geomorphological parameters using multi-temporal satellite images for the Godavari River, India. European Geosciences Union (EGU) General Assembly 2023 abstract. Vienna. 25th Apr 2023.",
      },
      {
        title:
          "Prashanth T, Ganguly S and Deb Barman S. Analyzing the spatio-temporal changes of various fluvial and geomorphological parameters for the Kinnerasani River, India. International Conference on River Corridor Research and Management. 15th June 2023. Organized by IIT Jammu and IIT Guwahati, India.",
      },
      {
        title:
          "Goswami, R., Das, R and Ganguly, S. Performance Analysis of Salt Gradient Thermal Storage Device Driven by Waste Heat, 2023 3rd International Conference on Electrical, Computer, Communications and Mechatronics Engineering (ICECCME), Tenerife, Canary Islands, Spain, 2023.",
      },
      {
        title:
          "Goswami R, Das, R and Ganguly S. Zero waste production technology investigating through gasification process and characterization of its byproducts (biochar/bio-oil). The 9th International Symposium on Hydrogen Energy, Renewable Energy and Materials. (HEREM 2023). Bangkok, Thailand. 13-14 Oct 2023.",
      },
      {
        title:
          "Ganguly S, Prashanth T and Banerjee D. Figuring out Suitable Locations for Artificial Groundwater Recharge Based on AHP-ANN and Electrical Resistivity Survey. MedGU-23 Annual Meeting. Istanbul, Turkey, 26-30th Nov 2023.",
      },
      {
        title:
          "Prashanth T, Ganguly S, Banerjee D and Ganguly S. Groundwater vulnerability assessment using GIS based DRASTIC model and Electrical Resistivity Tomography method in and around Rupnagar City, Punjab, India. Hydro 2023 International, NIT Warangal, India, 21-23rd Dec 2023. (Best paper award 3rd position for Thallam Prashanth in the theme ‘Groundwater Hydrology’)",
      },
      {
        title:
          "Banerjee D and Ganguly S. Deep Learning-based groundwater level and recharge forecasts under changing climate scenarios: A case study on North-Western India. American Geophysical Union (AGU) Fall Meeting 2023 abstract. San Francisco, Dec 2023. (online presentation on 23rd Jan 2024)",
      },
      {
        title:
          "Jaiswal, M., Sebastian, R., & Mulaveesala, R (2023), 'Modulated thermal wave imaging approach to detect subsurface microcracks and their coalescence in deep mines for rock burst (strain burst) prediction', 15th International ISRM Congress 2023 & 72nd Geomechanics Colloquium, Paper Number: ISRM-15 CONGRESS-2023-064.",
      },
      {
        title:
          "Saha, K. & Sebastian, R. (2023), 'Shear wave propagation across jointed rocks of varying seismic impedance', 15th International ISRM Congress 2023 & 72nd Geomechanics Colloquium, Paper Number: ISRM-15 CONGRESS-2023-323.",
      },
      {
        title:
          "Rohilla, S. & Sebastian, R. (2023), 'Study of stress-dependent dynamic properties of jointed rock using resonant column apparatus', 15th International ISRM Congress 2023 & 72nd Geomechanics Colloquium, Paper Number: ISRM-15 CONGRESS-2023-385.",
      },
      {
        title:
          "Sebastian, R & Saha, K. (2023), 'Numerical simulation of shear wave propagation through jointed rocks', Proceedings of the 5th International conference on numerical modelling in engineering, Volume 2, Numerical Modelling in Mechanical and Materials Engineering, NME 2022, 23–24 August, Ghent University, Belgium.",
      },
    ],

    bookdata: [
      {
        title:
          "S. Singh, V. Sood, R. K. Tiwari, D.K. Gupta, D. Long (2023) Earth Observation using Scatterometer: State-of-the-Art Techniques,Applications, and Challenges, ELSEVIER, Academic Press (In Press).",
      },
    ],

    journaldata: [
      {
        title:
          "Ankit Tyagi, Reet Kamal Tiwari and Naveen James (2023). Prediction of the Future Landslide Susceptibility Scenario Based on LULC and Climate Projections. Landslides. https://doi.org/10.1007/s10346-023-02088-6.",
      },
      {
        title:
          "U., Veena and Naveen James (2023). Natural Rubber Latex Treatment of Sand: A Novel Remediation Technique for Soil Liquefaction. Soil Dynamics and Earthquake Engineering. 165, https://doi.org/10.1016/j.soildyn.2022.107661.",
      },
      {
        title:
          "Tyagi, A., Tiwari, R. K., & James, N. (2023). Identification of the significant parameters in spatial prediction of landslide hazard. Bulletin of Engineering Geology and the Environment, 82(8), 307. https://doi.org/10.1007/s10064-023-03334-w",
      },
      {
        title:
          "Gupta, N., and Chavan, S. R. (2023). A comprehensive decision support system for the characterization of probability distribution tails for daily precipitation. Journal of Hydrology, 626, 130282. https://doi.org/10.1016/j.jhydrol.2023.130282. (Impact factor: 6.4 and Q1 journal).",
      },
      {
        title:
          "Gupta, N., and Chavan, S. R. (2023). Assessment of changes in monthly streamflow using innovative polygon trend analysis in the South Indian Rivers. Arabian Journal of Geosciences, 16(12), 657. https://doi.org/10.1007/s12517-023-11767-6. (Impact factor: 0.406 and Q2 journal).",
      },
      {
        title:
          "Maheshwari, S., and Chavan, S. R. (2023). Exploring the dependence between discharge indices and catchment descriptors for suspended sediment load in Indian Rivers. ISH Journal of Hydraulic Engineering, 29(4), 505-513, doi: 10.1080/09715010.2022.2104624. (CiteScore (Scopus): 4.5 and Q2 journal)",
      },
      {
        title:
          "Gupta, N., and Chavan, S. R. (2023). Investigating the tail behaviour and associated risk with daily discharges in South Indian Rivers. Stochastic Environmental Research and Risk Assessment, 37, 3383–3399 (2023). https://doi.org/10.1007/s00477-023-02453-w. (Impact factor: 4.2 and Q1 journal).",
      },
      {
        title:
          "Chiru Naik, D., Chavan, S. R., & Sonali, P. (2023). Incorporating the climate oscillations in the computation of meteorological drought over India. Natural Hazards, 117, 2617–2646, https://doi.org/10.1007/s11069-023-05958-3. (Impact factor: 3.7 and Q1 journal)",
      },
      {
        title:
          "Maheshwari, S. and Chavan, S.R., (2023). A modified approach to determine mean sediment load and related discharge indices for suspended sediment transport. Journal of Hydrology, 7,p.128832. (Impact factor: 6.4 and Q1 journal)",
      },
      {
        title:
          "Saikia SK and Rajput AS, 'Understanding the Captured CO2 Utilisation Potential of Various Cementitious Materials Through Review and Analytical Modelling', Magazine of Concrete Research, IF-2.674, Vol, pp 1-47, July 2023, DOI: https://doi.org/10.1680/jmacr.22.00313.",
      },
      {
        title:
          "Aaditya, Bh., Rahul, T.M, 2023. Analysis of trip frequency choice of commute trips in the context of COVID-19 in India: A hybrid choice modelling approach with generalized ordered logit kernel. International Association of Traffic and Safety Sciences, 47(4), 557-565.",
      },
      {
        title:
          "Nitheesh K., Bhavathrathan, B.K., Manoj, M., Rahul, T.M., 2023. A risk minimization based approach for planning evacuation trip distribution. International Journal of Disaster Risk Reduction 97,104051 (Elsevier).",
      },
      {
        title:
          "Aaditya, Bh., Rahul, T.M, 2023. Long-term impacts of COVID-19 pandemic on travel behaviour. Travel Behaviour and Society 30, 262-270 (Elsevier).",
      },
      {
        title:
          "Padalu PKVR and Surana M. (2023). An Overview of Performance-Based Seismic Design Framework for Reinforced Concrete Frame Buildings, Iranian Journal of Science and Technology, Transactions of Civil Engineering, https://doi.org/10.1007/s40996-023-01217-4.",
      },
      {
        title:
          "KKK Reddy, Putul Haldar* and Shweta Mishra, (Accepted 26 Sep., 2023), 'Parametric Study on Chronological Evolution of Seismic Design Provisions for Indian RC Shear Wall Buildings', Journal of Vibration Engineering & Technologies, DOI: https://doi.org/10.1007/s42417-023-01145-7.",
      },
      {
        title:
          "Tripathi, A., Malik, K., Reshi, A. R., Moniruzzaman, M., & Tiwari, R. K. (2023). Multi-temporal SAR Interferometry (MTInSAR)-based study of surface subsidence and its impact on Krishna Godavari (KG) basin in India: a support vector approach. Environmental Monitoring and Assessment, 195(11), 1298.",
      },
      {
        title:
          "Kumar, M., Tiwari, R. K., Kumar, K., & Rautela, K. S. (2023). Statistical evaluation of snow accumulation and depletion from remotely sensed MODIS snow time series data using the SARIMA model. AQUA-Water Infrastructure, Ecosystems and Society, 72(3), 348-362.",
      },
      {
        title:
          "Kumar, M., Tiwari, R. K., Kumar, K., & Rautela, K. S. (2023). Prioritization of Sub watersheds for the Categorization of Surface Runoff and Sediment Production Rate Based on Geo-spatial Modeling and PCA Approach: A Case from Upper Beas River, Himachal Pradesh, India. Journal of the Geological Society of India, 99(4), 545-553.",
      },
      {
        title:
          "Kaur, R., Tiwari, R. K., Maini, R., & Singh, S. (2023). A Framework for Crop Yield Estimation and Change Detection Using Image Fusion of Microwave and Optical Satellite Dataset. Quaternary, 6(2).",
      },
      {
        title:
          "Guha, S., & Tiwari, R. K. (2023). Analyzing geomorphological and topographical controls for the heterogeneous glacier mass balance in the Sikkim Himalayas. Journal of Mountain Science, 20(7), 1854-1864.",
      },
      {
        title:
          "Tyagi, A., Tiwari, R. K., & James, N. (2023). Prediction of the future landslide susceptibility scenario based on LULC and climate projections. Landslides, 1-16.",
      },
      {
        title:
          "Tyagi, A., Tiwari, R. K., & James, N. (2023). Mapping the landslide susceptibility considering future land-use land-cover scenario. Landslides, 20(1), 65-76.",
      },
      {
        title:
          "Tyagi, A., Tiwari, R. K., & James, N. (2023). Identification of the significant parameters in spatial prediction of landslide hazard. Bulletin of Engineering Geology and the Environment, 82(8), 307.",
      },
      {
        title:
          "Banerjee D and Ganguly S. A Review on the Research Advances in Groundwater–Surface Water Interaction with an Overview of the Phenomenon. Water. Vol. 15 (8), April 2023, pp. 1552.",
      },
      {
        title:
          "Hydrogeochemical constraints on uranium contamination of groundwater for drinking water supplies and associated health risks. M Verma, VA Loganathan. Groundwater for Sustainable Development. 2023; 100973.",
      },
      {
        title:
          "Experiments and geochemical modelling of arsenic interaction with clay-dominated soil from Rupnagar district of Punjab, India. H Nazir, VA Loganathan. Water Security. 2023; 100139.",
      },
      {
        title:
          "Water security and health risk assessment of an urban household-level drinking water and sanitation system, Punjab, India. Mohit Verma, VA Loganathan. Environmental Monitoring and Assessment. 2023; 195 (6).",
      },
      {
        title:
          "Release of geogenic fluoride from contaminated soils of Rajasthan, India: Experiments and geochemical modeling. B Thakur, VA Loganathan et al. Water Security. 2023; 100140.",
      },
      {
        title:
          "Separation of nanoplastics from synthetic and industrial wastewater using electrolysis-assisted flotation approach: A green approach for real-time contaminant mitigation. VS Pawak, C Shekhar, VA Loganathan, & Manigandan Sabapathy. Chemical Engineering Research and Design. 2023.",
      },
      {
        title:
          "Ganesh, R., and J. P. Sahoo. 2023. Kinematic horizontal slice method for uplift capacity analysis of plate anchors in nonhomogeneous soils with a nonlinear failure criterion. Computers and Geotechnics, Elsevier Sci Ltd, England. 159, 105407. Impact Factor: 5.218/2021. https://doi.org/10.1016/j.compgeo.2023.105407.",
      },
      {
        title:
          "Gani, A., Pathak, S., Hussain, A., Ahmed, S., Singh, R., Khevariya, A., Banerjee, A., Ayyamperumal, R., Bahadur, A. (2023). Water Quality Index Assessment of River Ganga at Haridwar Stretch Using Multivariate Statistical Technique, Molecular Biotechnology, 1-24, doi: https://doi.org/10.1007/s12033-023-00864-2. SCI Journal, IF- 2.6.",
      },
      {
        title:
          "Saha, K & Sebastian, R (2023), “Dynamic behaviour of rock joint during shear wave propagation: The influence of joint orientation”, Rock Mechanics and Rock Engineering, DOI : 10.1007/s00603-023-03475-0 (Impact Factor:6.2)",
      },
      {
        title:
          "Rohilla, S & Sebastian, R (2023), “Determination of joint roughness coefficient using a cost – effective photogrammetry technique”, Bulletin of Engineering Geology and the Environment, Springer, 82, paper no. 125. (Impact Factor:4.2)",
      },
      {
        title:
          "Rohilla, S & Sebastian, R (2023), “Resonant column and cyclic torsional shear tests on Sutlej river sand subjected to the seismicity of Himalayan and Shivalik hill ranges: A case study”, Soil Dynamics and Earthquake Engineering, Elsevier, 166, paper no. 107766. (Impact Factor: 4.0).",
      },
    ],
  },

  2024: {
    conferencedata: [
      {
        title:
          'Kushwaha S, Naveen James, Tiwari RK, Veena U, Tyagi A and Kannan M (2024) "Slope Stability Analysis and Remediation Measures Against Slope Failure at Kullu, India: Case Study. XIVth International Symposium on Landslides, Chambéry, France.',
      },
      {
        title:
          'Shylu, K. A, Tiwari RK, Naveen James (2024) "Detection and Mapping of Actively Deforming Areas Using PsInsaR for Landslide Monitoring in Himachal Pradesh, India". XIVth International Symposium on Landslides, Chambéry, France.',
      },
      {
        title:
          'Suresh, K. A, Naveen James, Tiwari RK (2024) "Quantifying Landslide Activity Using UAV And TLS: A Case Study of Soldha Landslide in Kangra, Himachal Pradesh, India". XIVth International Symposium on Landslides, Chambéry, France.',
      },
      {
        title:
          'Sharma., S and Naveen James (2024). "Cyclic Response of Natural Rubber Latex treated Sutlej Sand Under Stress Controlled Loading" 8th International Conference on Recent Advances in Geotechnical Earthquake and Soil Dynamics, IIT Guwahati.',
      },
      {
        title:
          'U., Veena and Naveen James (2024). "Liquefaction Mitigation Using Natural Rubber Latex Treatment" 8th International Conference on Recent Advances in Geotechnical Earthquake and Soil Dynamics, IIT Guwahati.',
      },
      {
        title:
          'U., Veena and Naveen James (2024). "Evaluation of Dynamic Properties of Sand Treated with Natural Rubber Latex for Seismic Isolation" Geo-Congress 2024, Vancouver. https://doi.org/10.1061/9780784485309.040.',
      },
      {
        title:
          "Badoni, A., & Chavan, S. R., (2024). Bivariate Flood Frequency Analysis of Krishna River using Copula Theory. EGU24- 18700.",
      },
      {
        title:
          "Gaur, N., & Chavan, S. R., (2024). Assessment of Compound Drought and Hot Extreme Conditions Over West Rajasthan, India. EGU24- 18117.",
      },
      {
        title:
          "Rana, S., & Chavan, S. R., (2024). Assessing the sensitivity of geomorphological attributes to DEM source and Spatial Resolutions. EGU24-16998.",
      },
      {
        title:
          "Singh, A., & Chavan, S. R., (2024). Regional Flood Frequency Analysis Utilizing LH-moment based framework for Godavari River Basin. EGU24-15968.",
      },
      {
        title:
          "Dahiwale, A. V., Chavan, S. R., & Sarmah, R. (2024). Estimation of Sediment Yield using Geomorphologic Instantaneous Unit Sedimentgraph for Seer Khand Catchment in India. AGU23.",
      },
      {
        title:
          "Varshney, A., Chavan, S. R., & Kashyap, D. (2024). Effects of Human-induced Climate Change on Irrigation Demands of Existing Cropping Patterns in Indo-Gangetic Planes. AGU23.",
      },
      {
        title:
          "Varshney, A., Kashyap, D., & Chavan, S. R. (2024). Suitability of Cropping Pattern for modified groundwater availability under future climate change. AGU23.",
      },
      {
        title:
          "Amini SN and Rajput AS; Assessing the Seismic Performance of Lightly reinforced Columns Under The Influence of Corrosion: An Experimental and Numerical Study; World Conference on Earthquake Engineering, June 30-July 5-2024, Milan, Italy.",
      },
      {
        title:
          "Ahmad, Hafsoah, Rahul, T.M.,2024. Decoding the factors shaping GenZ and Millennial choices of electric two-wheeler ownership. 17th International Conference on Travel Behavior Research, Vienna.",
      },
      {
        title:
          "Ahmad, Hafsoah, Rahul, T.M.,2024. Effect of information provision on electric vehicle purchase intention in GMM-clustered groups: a single arm pre-post intervention study. 17th International Conference on Travel Behavior Research, Vienna.",
      },
      {
        title:
          "Nikhil, Aaditya, Bh., Rahul, T.M., 2024. Extending the scope of discrete choice frameworks with latent variables to manage missing data. International conference on Choice Modelling 2024, Chile (Accepted for presentation).",
      },
      {
        title:
          'Hibretu Kaske Kasa, Putul Haldar*, Adil Ahmad (Full paper Accepted 12 Jan 24), "FEA of the in-plane behaviour of reinforced concrete sandwich panels with an EPS core", 18th World Conference on Earthquake Engineering (WCEE2024), in Milan, Italy, from 30th June to 5th July 2024.',
      },
      {
        title:
          'Manoj Kannan Rajamanickam, Naveen James, Putul Haldar (Abstract No. 244, 2024), "Effect of Shallow Rocking Foundation on Seismic Energy Dissipation Capacity and Self-Centering Ability of RC Framed Buildings", 8th International Conference on Recent Advances in Geotechnical Earthquake EngineeringandSoilDynamics,11-14 December 2024, IIT Guwahati, India.',
      },
      {
        title:
          'Shweta Mishra, Putul Haldar, and Indramani Dhada, (Paper ID H0009 Accepted), "Effectiveness of TiO2-Anatase & Rutile Phase in Photocatalytic Reduction of Urban Air Pollution", 18th East Asia-Pacific Conference on Structural Engineering and Construction (EASEC-18), 13–15 November 2024, Chiang Mai, Thailand.',
      },
      {
        title:
          'Onkar Mishra, Putul Haldar, Amar Nath Roy Chowdhury, (Paper ID H0009 Accepted), "Nonlinear Finite Element Assessment of Bolted Precast Beam-Column Connection: A Parametric Study", 18th East Asia-Pacific Conference on Structural Engineering and Construction (EASEC-18), 13–15 November 2024, Chiang Mai, Thailand.',
      },
      {
        title:
          'Onkar Mishra, Putul Haldar, Amar Nath Roy Chowdhury (Abstract Accepted) "A Concurrent Multi-scale Finite Element Framework for Precast Bolted Beam-Column Connection", 1st International Conference on Net-Zero Built Environment: Innovations in Materials, Structures, and Management Practices, June 19-21, 2024, Oslo, Norway.',
      },
      {
        title:
          "Zimmy Singh Naorem, and Putul Haldar (Abstract Accepted) “Influence of Openings on Seismic Failure Mechanism of URM Infilled RC Hill Buildings”, 1st International Conference on Net-Zero Built Environment: Innovations in Materials, Structures, and Management Practices, June 19-21, 2024, Oslo, Norway.",
      },
      {
        title:
          "Shweta Mishra, Putul Haldar, and Indramani Dhada, (Paper ID 467791 Accepted), “Experimental Investigation of Photocatalytic Efficiency of TiO2 in Reducing Urban Air Pollution”, 7th International Conference Series on Geotechnics, Civil Engineering and Structures (CIGOS-2024), 04-05 April 2024, Ho Chi Minh City, Vietnam.",
      },
      {
        title:
          'Onkar Mishra, Putul Haldar, Amar Nath Roy Chowdhury (Abstract Accepted) “A Concurrent Multi-scale Finite Element Framework for Precast Bolted Beam-Column Connection", 1st International Conference on Net-Zero Built Environment: Innovations in Materials, Structures, and Management Practices, June 19-21, 2024, Oslo, Norway.',
      },
      {
        title:
          "Prashanth T., Ganguly S., Gummadi M., and Dharmraj. Identification and mapping the surface water bodies that are sensitive to groundwater drought in the Godavari basin, India. European Geosciences Union (EGU) General Assembly 2024 abstract. 18th Apr 2024. doi: 10.5194/egusphere-egu24-55.",
      },
      {
        title:
          "Das A, Banerjee D and Ganguly S. Assessment of the evolution of groundwater quality for the state of California, United States using weighted index overlay analysis. European Geosciences Union (EGU) General Assembly 2024 abstract. Vienna. 16th Apr 2024. doi: 10.5194/egusphere-egu24-8383.",
      },
      {
        title:
          "Ganguly S, Das A and Banerjee D. Assessment of the Evolution of Groundwater Quality Using Machine Learning and Deep Learning Models. AOGS Annual Meeting 2024. Pyeongchang, South Korea, 23-28th June 2024.",
      },
      {
        title:
          "Ganguly S and Ganguly S. Numerical Modelling on the Transport and Fate of Hexavalent Chromium Leaked from a Landfill Site. India-Dalhousie Student Research Symposium. The online event, April 3-4, 2024.",
      },
      {
        title:
          "Prashanth T. and Ganguly S. Estimation of suspended sediment concentration and discharge by using satellite derived bathymetry technique for the South Indian Rivers. Poster presentation in State of the Art Techniques in River Corridor Research and Management: An Indo-French Perspective. IIT Delhi. 4-5th July 2024.",
      },
      {
        title:
          "Prashanth T, Ganguly S, Mohanta, B.K. and Ganguly S. Groundwater vulnerability assessment due to seawater intrusion by integrating well–logging, machine learning & MCDA techniques. American Geophysical Union (AGU) Fall Meeting 2024 abstract. To be held in San Francisco, USA in Dec 2024 (abstract submitted).",
      },
      {
        title:
          "Ganguly S and Ganguly S. On the natural adsorption capacity of the ambient soil of Rupnagar, Punjab, India to attenuate Cr (VI) plume: Insights into the fate & transport and associated health risks. American Geophysical Union (AGU) Fall Meeting 2024 abstract. To be held in San Francisco, USA in Dec 2024 (abstract submitted).",
      },
      {
        title:
          "Banerjee D Ganguly S and Tsai W-P. Precipitation Nowcasting using Convolutional Long Short-Term Memory (ConvLSTM): A case study in Punjab, India. American Geophysical Union (AGU) Fall Meeting 2024 abstract. San Francisco, Dec 2024 (abstract submitted).",
      },
      {
        title:
          "Mitigation of U (VI) and Se (VI) contaminated groundwater via forward osmosis: Insights on removal mechanism and co-ion effect. M Verma, VA Loganathan. Goldschmidt Conference 2024, Chicago, IL. 2024.",
      },
      {
        title:
          "Dissolved organic matter influences U(VI) removal in ultrafiltration process M Verma, VA Loganathan.ACS Fall 2024, August 18-22, 2024, Denver, CO.",
      },
      {
        title:
          "A comprehensive Water Security Index for assessing household-level drinking water supply and Sanitation infrastructure of Punjab, India. Mohit Verma, Vijay A Loganathan.2024/2. National Environment Conference. Environmental Science and Engineering Department, IIT Bombay. February 15-17, 2024.",
      },
      {
        title:
          "Ratan Sarmah, Sagar Rohidas Chavan and Ickkshaanshu Sonkar (2024). Analytical solution of the linearized Boussinesq equation considering time-dependent downslope boundary, variable recharge and bedrock seepage. Water Resources Management 38, 1563–1585.",
      },
      {
        title:
          "Amit Kumar, Ickkshaanshu Sonkar and Ratan Sarmah (2024). Modeling root zone water and salt transport using matric flux potential based root water uptake distribution. Journal of Hydrology 630, 130712.",
      },
    ],

    bookdata: [
      {
        title:
          "Hydraulic Engineering 2024 (tentative) Publisher: All India Council for Technical Education (AICTE) Dr. Sayantan Ganguly",
      },
      {
        title:
          "Sustainable Development and Geospatial Technology: Innovations and Best practices, Vol-I Publisher: Springer Nature",
      },
      {
        title:
          "Sustainable Development and Geospatial Technology: Innovations and Best practices, Vol-I Publisher: Springer Nature",
      },
      {
        title:
          "Intelligent Infrastructure and Smart Materials: Sustainable Technologies for a Greener Future Publisher: Springer Nature",
      },
    ],

    journaldata: [
      {
        "title": "Kannan, R.M., Naveen James, & Haldar, P. (2024). Seismic Response of Rocking Shallow Foundation in RC Framed Structure: A Parametric Study"
      },
      {
        "title": "Kannan RM, Putul Haldar and Naveen James (2024). Isolated shallow rocking foundation on different soils with varying embedment depth"
      },
      {
        "title": "Sarmah, R., Chavan, S. R., & Sonkar, I. (2024). Analytical Solution of the Linearized Boussinesq Equation Considering Time-Dependent Downslope Boundary, Variable Recharge and Bedrock Seepage"
      },
      {
        "title": "Gupta, N., & Chavan, S. R. (2024). Assessing future changes in daily precipitation tails over India: insights from multimodel assessment of CMIP6 GCMs"
      },
      {
        "title": "Saikia SK and Rajput AS, (2024). Effect of carbon sequestration methods on uptake potential and characteristics of ordinary Portland cement-based concrete"
      },
      {
        "title": "Saikia SK, Rajput AS, and Saini K, (2024). Effect of employing carbon sequestration technologies while using electric arc furnace ash in cementitious binder"
      },
      {
        "title": "Amini SN and Rajput AS, (2024). Seismic Response Assessment of Ductile Reinforced Concrete Columns Affected by Corrosion and Axial Load Variations"
      },
      {
        "title": "Saikia SK, Rajput AS, and Saini K, (2024). Utilizing Ground Granulated Blast Furnace Slag for Carbon Sequestration in Concrete"
      },
      {
        "title": "Saini K, Saikia SK, and Rajput AS, (2024). Durability Assessment of Ground Granulated Blast Furnace Slag-Based Carbon Sequestered Concrete"
      },
      {
        "title": "Amini SN and Rajput AS, (2024). Effect of Reinforcement Corrosion and Axial Load Levels on Seismic Response of Non-Ductile Reinforced Concrete Columns"
      },
      {
        "title": "Amini SN and Rajput AS, (2024). Seismic Performance of Ductile and Non-Ductile Reinforced Concrete Columns Under Varied Axial Compression"
      },
      {
        "title": "Ahmad, Hafsoah, Rahul, T.M. (2024). Targeted information intervention among consumer clusters for electric vehicle penetration – A case study of Punjab, India"
      },
      {
        "title": "Gayathri R Prasad and Raheena M (2024). Behaviour and stabilization of a soft clay from Allepey district, Kerala- A review"
      },
      {
        "title": "Niraj Janardhan Sahare and Raheena M (2024). Swell-Shrink and microstructural response of expansive soil treated with nanomaterials"
      },
      {
        "title": "Baldev D, Modgil T, Surana M, Haldar P, Singh Y and Pathak J (2024). Sustainable Local Seismic Culture in Vernacular Buildings of the Indian Himalayas"
      },
      {
        "title": "Kannan, R.M., Naveen James, & Haldar, P. (2024). Seismic Response of Rocking Shallow Foundation in RC Framed Structure: A Parametric Study"
      },
      {
        "title": "Kannan RM, Putul Haldar and Naveen James (2024). Isolated shallow rocking foundation on different soils with varying embedment depth"
      },
      {
        "title": "Sarmah, R., Chavan, S. R., & Sonkar, I. (2024). Analytical Solution of the Linearized Boussinesq Equation Considering Time-Dependent Downslope Boundary, Variable Recharge and Bedrock Seepage"
      },
      {
        "title": "Gupta, N., & Chavan, S. R. (2024). Assessing future changes in daily precipitation tails over India: insights from multimodel assessment of CMIP6 GCMs"
      },
      {
        "title": "Saikia SK and Rajput AS, (2024). Effect of carbon sequestration methods on uptake potential and characteristics of ordinary Portland cement-based concrete"
      },
      {
        "title": "Saikia SK, Rajput AS, and Saini K, (2024). Effect of employing carbon sequestration technologies while using electric arc furnace ash in cementitious binder"
      },
      {
        "title": "Amini SN and Rajput AS, (2024). Seismic Response Assessment of Ductile Reinforced Concrete Columns Affected by Corrosion and Axial Load Variations"
      },
      {
        "title": "Saikia SK, Rajput AS, and Saini K, (2024). Utilizing Ground Granulated Blast Furnace Slag for Carbon Sequestration in Concrete"
      },
      {
        "title": "Saini K, Saikia SK, and Rajput AS, (2024). Durability Assessment of Ground Granulated Blast Furnace Slag-Based Carbon Sequestered Concrete"
      },
      {
        "title": "Amini SN and Rajput AS, (2024). Effect of Reinforcement Corrosion and Axial Load Levels on Seismic Response of Non-Ductile Reinforced Concrete Columns"
      },
      {
        "title": "Amini SN and Rajput AS, (2024). Seismic Performance of Ductile and Non-Ductile Reinforced Concrete Columns Under Varied Axial Compression"
      },
      {
        "title": "Ahmad, Hafsoah, Rahul, T.M. (2024). Targeted information intervention among consumer clusters for electric vehicle penetration – A case study of Punjab, India"
      },
      {
        "title": "Gayathri R Prasad and Raheena M (2024). Behaviour and stabilization of a soft clay from Allepey district, Kerala- A review"
      },
      {
        "title": "Niraj Janardhan Sahare and Raheena M (2024). Swell-Shrink and microstructural response of expansive soil treated with nanomaterials"
      },
      {
        "title": "Baldev D, Modgil T, Surana M, Haldar P, Singh Y and Pathak J (2024). Sustainable Local Seismic Culture in Vernacular Buildings of the Indian Himalayas"
      },
      {
        "title": "Jain A and Surana M (2024). In-Plan Distribution of Peak Floor Acceleration Demands in Torsionally Irregular Buildings"
      },
      {
        "title": "Latif I, Surana M, Banerjee A (2024). Effect of Material Properties Uncertainty on Seismic Fragility of Reinforced-Concrete Frames Using Machine Learning Approach"
      },
      {
        "title": "Jain A and Surana M (2024). Peak Floor Acceleration Demands in Torsionally Irregular Buildings"
      },
      {
        "title": "Dharmil Baldev, Tuhinanshu Modgil, Mitesh Surana, Putul Haldar, Yogendra Singh and Jayanta Pathak (2024). Sustainable Local Seismic Culture in Vernacular Buildings of the Indian Himalayas: Field Observations, Knowledge Dissemination, and Recommendations"
      },
      {
        "title": "K. K. K. Reddy and Putul Haldar (2024). Influence of Effective Stiffness on Seismic Response of RC Shear Wall Buildings"
      },
      {
        "title": "Panna Lal Kurmi, and Putul Haldar (2024). Collapse Assessment of Irregular Infilled RC Buildings Compliant to Indian Design Standards"
      },
      {
        "title": "Manoj Kannan, Rajamanickam, Naveen James, Putul Haldar (2024). Seismic Performance of RC Framed Structures on Rocking Foundation: A Parametric Study"
      },
      {
        "title": "Panna Lal Kurmi, and Putul Haldar (2024). Comparative Study of Code Prescribed Design Interventions for Open Ground Storey Buildings in India"
      },
      {
        "title": "Manoj Kannan Rajamanickam, Putul Haldar, Naveen James (2024). Isolated Shallow Rocking Foundation on Different Soils with Varying Embedment Depth"
      },
      {
        "title": "Zimmy Singh Naorem, Putul Haldar (2024). Effect of Seismic Design Provisions of Indian Standards on Seismic Response of URM Infilled RC Step-Back Building on Hill"
      },
      {
        "title": "Das S, Shri N, Chakraborty P, Dhada I, Adhikari A, Kannan K, Padhy P K (2024). Spatio-temporal trends in deaths due to cardiovascular diseases attributable to air pollution in India and its states: evidence from the Global Burden of Disease study 2019"
      },
      {
        "title": "Sudesan, S., Sonkar, I., K. S., H. P., &amp;amp; Chandra Shekhar Prasad, O. (2024). Experimental study to understand the effects of deficit irrigation in maize"
      },
      {
        "title": "Sarmah, R., Chavan, S. R., &amp;amp; Sonkar, I. (2024). Analytical Solution of the Linearized Boussinesq Equation Considering Time-Dependent Downslope Boundary, Variable Recharge and Bedrock Seepage"
      },
      {
        "title": "Goet, G., Sonkar, I., Kumar, S., Hari Prasad, K. S., &amp;amp; Ojha, C. S. P. (2024). Effect of Salinity on Crop Growth and Soil Moisture Dynamics: A Study with Root Water Uptake Model"
      },
      {
        "title": "Kumar, A., Sonkar, I., &amp;amp; Sarmah, R. (2024). Modeling root zone water and salt transport using matric flux potential based root water uptake distribution"
      },
      {
        "title": "Goswami, R., Ganguly, S and Das, R. (2024). Waste heat recovery from the biomass engine for effective power generation using a new array-based system"
      },
      {
        "title": "Banerjee, D., Ganguly, S. &amp; Kushwaha, S. (2024). Forecasting Future Groundwater Recharge from Rainfall Under Different Climate Change Scenarios Using Comparative Analysis of Deep Learning and Ensemble Learning Techniques"
      },
      {
        "title": "Ganguly, S and Ganguly, S. (2024). Addition of Magnetite Nanoparticles and Chitin Biopolymer Powders into the Ambient Sandy Loam Soil for the Effective Removal of Cr(VI): Batch Adsorption and Optimization Study by Response Surface Methodology"
      },
      {
        "title": "Mitigation via forward osmosis: elucidation of retention mechanisms and co-ion effects. M Verma, VA Loganathan. (2024)."
      },
      {
        "title": "Investigation of forward osmosis process for selenium mitigation from environmentally-relevant groundwater systems. M Verma, VA Loganathan. (2024)."
      },
      {
        "title": "Insights on the mechanism of uranium removal via nanofiltration in alkalinity and salinity dominated groundwater systems. M Verma, VA Loganathan. (2024)."
      },
      {
        "title": "Ganesh, R. (2024). Pullout capacity analysis of horizontal plate anchors with tensile strength cutoff"
      },
      {
        title: "Pathak, S., Sharma, S., Banerjee, A., Kumar, S. (2024). A methodology to assess and evaluate sites with high potential for stormwater harvesting in Dehradun, India"
      },
      {
        title: "Gani, A., Pathak, S., Hussain, A. (2024). Comprehensive Analysis of Modified Heavy Metal Pollution Index and Health Risk Assessment in the Yamuna River of Delhi, India: A Crucial Study for Environmental Health Management"
      },
      {
        title: "Gani, A., Singh, M., Pathak, S., Hussain, A. (2024). Groundwater Quality Index Development using ANN Model of Delhi Metropolitan City, India"
      },
      {
        title: "Gani, A., Pathak, S., Hussain, A., Shukla, A. K., Chand, S. (2024). Emerging Pollutant in Surface Water Bodies: A Review on Monitoring, Analysis, Mitigation Measures and Removal Technologies of Micro-plastics"
      },
      {
        title: "Sharma, S., Pathak, S., Kumar, S. (2024). A Planning-Support Tool for Spatial Suitability Assessment of Harvesting Sites for Stormwater Infrastructure"
      },
      {
        title: "Gani, A., Hussain, A., Pathak, S., Banerjee, A. (2024). An Empirical Investigation on the Elimination of Heavy Metals Using Bioremediation Method for Selected Plant Species"
      },
      {
        title: "Gani, A., Hussain, A., Pathak, S., Omar, P. J. (2024). Analysing Heavy Metal Contamination in Groundwater in the Vicinity of Mumbai's Landfill Sites: An In-depth Study"
      },
      {
        title: "Hussain, A., Deshwal, A., Priyadarshi, M., Pathak, S., Sambandam, G., Chand, S., Shukla, A. K. (2024). Landfill leachate analysis from selected landfill sites and its impact on groundwater quality, New Delhi, India"
      },
      {
        title: "Yadav, N., Jianping Wu, J., Banerjee, A., Pathak, S., Garg, R. D., Yao, S. (2024). Climate uncertainty and vulnerability of urban flooding associated with regional risk using multi-criteria analysis in western coast of India"
      },
    
    ],
  },
};

export default function YearlyResearch() {

  const { year } = useParams();

  const [show, setShow] = useState(1);

  const handleclick = (e) => {
    setShow(e);
  };

  const data = researchData[year] || { conference: [], book: [], journal: [] };

  return (
    <>
      <Nav />

      <div className="main-container">
        <div className="page-banner">
          <div className="text">
            <p>
              <Link
                to="https://www.iitrpr.ac.in/civil/"
                className="backlink"
                style={{
                  color: "white",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
              >
                Home
              </Link>{" "}
              /{" "}
              <Link
                to="/research"
                className="backlink"
                style={{
                  color: "white",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
              >
                Research
              </Link>{" "}
              / {year}
            </p>
          </div>
        </div>

        <div className="divide-container">
          <div className="left-container">
            <div className="year-nav">
              <ul>
                <li className={show === 1 ? "active-side-nav" : ""}>
                  <a
                    onClick={() => {
                      handleclick(1);
                    }}
                  >
                    Conference Publication
                  </a>
                </li>
                <li className={show === 2 ? "active-side-nav" : ""}>
                  <a
                    onClick={() => {
                      handleclick(2);
                    }}
                  >
                    Book Chapter
                  </a>
                </li>
                <li className={show === 3 ? "active-side-nav" : ""}>
                  <a
                    onClick={() => {
                      handleclick(3);
                    }}
                  >
                    Journal Publication
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="right-container">
            <div className="year-content">
              <div className={show == 1 ? "conference" : "hide"}>
                <ul>
                  <h2>Conference Publication</h2>
                  {data.conferencedata.map((items) => (
                    <li>{items.title}</li>
                  ))}
                </ul>
              </div>

              <div className={show == 2 ? "book" : "hide"}>
                <ul>
                  <h2>Book Chapter</h2>
                  {data.bookdata.map((items) => (
                    <li>{items.title}</li>
                  ))}
                </ul>
              </div>

              <div className={show == 3 ? "journal" : "hide"}>
                <ul>
                  <h2>Journal Publication</h2>
                  {data.journaldata.map((items) => (
                    <li>{items.title}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
